import navClean from "./assets/nav-art-clean.png";
import navLinen from "./assets/nav-art-linen.png";
import navBotanical from "./assets/nav-art-botanical.png";
import navCoastal from "./assets/nav-art-coastal.png";
import navCafe from "./assets/nav-art-cafe.png";
import navPaper from "./assets/nav-art-paper.png";
import navStudy from "./assets/nav-art-study.png";
import navVintage from "./assets/nav-art-vintage.png";
import accountCleanFemale from "./assets/account-art-clean-female.png";
import accountCleanMale from "./assets/account-art-clean-male.png";
import accountLinenFemale from "./assets/account-art-linen.png";
import accountLinenMale from "./assets/account-art-linen-male.png";
import accountBotanicalFemale from "./assets/account-art-botanical.png";
import accountBotanicalMale from "./assets/account-art-botanical-male.png";
import accountCoastalFemale from "./assets/account-art-coastal.png";
import accountCoastalMale from "./assets/account-art-coastal-male.png";
import accountCafeFemale from "./assets/account-art-cafe.png";
import accountCafeMale from "./assets/account-art-cafe-male.png";
import accountPaperFemale from "./assets/account-art-paper.png";
import accountPaperMale from "./assets/account-art-paper-male.png";
import accountStudyFemale from "./assets/account-art-study.png";
import accountStudyMale from "./assets/account-art-study-male.png";
import accountVintageFemale from "./assets/account-art-vintage.png";
import accountVintageMale from "./assets/account-art-vintage-male.png";

(() => {
  const api = window.CleanApp;
  if (!api) return;
  const $ = (s, r = document) => r.querySelector(s),
    $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) =>
    String(s ?? "").replace(
      /[&<>"']/g,
      (c) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[c],
    );
  const validEventColor = (value) =>
    /^#[0-9a-f]{6}$/i.test(String(value || "")) ? String(value) : "";
  const flash = (msg) => {
    const t = $(".toast");
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(window.__flash);
    window.__flash = setTimeout(() => t.classList.remove("show"), 1600);
  };
  function refreshInterfaceCopy() {
    const pages = {
      tasks: ["Tasks and deadlines", "Create, schedule, and track tasks."],
      routines: [
        "Recurring plans",
        "Set schedules, track completions, and pause routines.",
      ],
      work: [
        "Work schedule",
        "Set regular hours, time off, and schedule exceptions.",
      ],
      notes: [
        "Notes and lists",
        "Write notes, pin them, or attach lists to your planner.",
      ],
      settings: [
        "Preferences",
        "Customize appearance, layout, calendar behavior, and accessibility.",
      ],
    };
    Object.entries(pages).forEach(([id, [eyebrow, description]]) => {
      const page = $("#page-" + id),
        head = $(".hub-head", page);
      if (!head) return;
      const eyebrowNode = $(".eyebrow", head),
        descriptionNode = $("h1 + p", head);
      if (eyebrowNode) eyebrowNode.textContent = eyebrow;
      if (descriptionNode) descriptionNode.textContent = description;
    });
    const sort = $("#page-tasks .card-head .chip");
    if (sort) sort.textContent = "Sort: priority";
    const routineRate = $(
      "#page-routines .summary-strip div:nth-child(3) span",
    );
    if (routineRate) routineRate.textContent = "completion rate";
    const weekLayout = $(
      "#page-settings .setting-block:nth-of-type(2) .setting-title p",
    );
    if (weekLayout)
      weekLayout.textContent = "Choose how dates and times are arranged.";
  }
  refreshInterfaceCopy();
  const PREFS_KEY = "clean-planner-prefs-v1";
  const prefs = Object.assign(
    {
      theme: "clean",
      scale: 100,
      glassOpacity: 68,
      layout: "columns",
      plannerMargin: true,
      workShading: true,
      mondayStart: true,
      morningBrief: true,
      routinePrompts: true,
      deadlinePrompts: false,
      deviceNotifications: false,
      roomyCards: false,
      expandedNav: true,
      reduceMotion: false,
      highContrast: false,
      largeControls: false,
      workSchedule: null,
    },
    JSON.parse(localStorage.getItem(PREFS_KEY) || "{}"),
  );
  const savePrefs = () => {
    const copy = { ...prefs };
    localStorage.setItem(PREFS_KEY, JSON.stringify(copy));
    window.dispatchEvent(
      new CustomEvent("guardian:preferences", { detail: copy }),
    );
  };
  document.body.dataset.theme = prefs.theme;
  document.documentElement.style.setProperty("--scale", prefs.scale / 100);
  document.documentElement.style.setProperty("--ui-density", prefs.scale / 100);
  document.documentElement.style.setProperty(
    "--glass-opacity",
    Math.max(0.05, Math.min(0.96, (prefs.glassOpacity ?? 68) / 100)),
  );
  const savedScale = $("#scale");
  if (savedScale) savedScale.value = prefs.scale;
  if (prefs.layout === "timegrid") $(".planner")?.classList.add("traditional");
  const navArtSources = {
    clean: navClean,
    linen: navLinen,
    botanical: navBotanical,
    coastal: navCoastal,
    cafe: navCafe,
    paper: navPaper,
    study: navStudy,
    vintage: navVintage,
  };
  const navArtCache = {};
  function applyNavigationArt(theme) {
    const art = navArtCache[theme];
    if (!art) return;
    Object.entries(art).forEach(([name, url]) =>
      document.documentElement.style.setProperty(
        `--nav-${name}`,
        `url("${url}")`,
      ),
    );
  }
  function prepareNavigationArt(
    theme = document.body.dataset.theme || "clean",
  ) {
    if (navArtCache[theme]) {
      applyNavigationArt(theme);
      return;
    }
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const context = canvas.getContext("2d", { willReadFrequently: true });
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height),
        data = pixels.data;
      for (let i = 0; i < data.length; i += 4) {
        const low = Math.min(data[i], data[i + 1], data[i + 2]),
          high = Math.max(data[i], data[i + 1], data[i + 2]);
        if (low > 246) data[i + 3] = 0;
        else if (low > 218 && high - low < 24)
          data[i + 3] = Math.round((data[i + 3] * (246 - low)) / 28);
      }
      context.putImageData(pixels, 0, 0);
      const names = [
          "calendar",
          "tasks",
          "routines",
          "work",
          "notes",
          "settings",
        ],
        cellWidth = canvas.width / 3,
        cellHeight = canvas.height / 2,
        art = {};
      names.forEach((name, index) => {
        const cellX = (index % 3) * cellWidth,
          cellY = Math.floor(index / 3) * cellHeight;
        let left = cellWidth,
          top = cellHeight,
          right = 0,
          bottom = 0;
        for (let y = 0; y < cellHeight; y += 2)
          for (let x = 0; x < cellWidth; x += 2) {
            if (data[((cellY + y) * canvas.width + cellX + x) * 4 + 3] > 24) {
              left = Math.min(left, x);
              right = Math.max(right, x);
              top = Math.min(top, y);
              bottom = Math.max(bottom, y);
            }
          }
        const width = Math.max(1, right - left),
          height = Math.max(1, bottom - top),
          size = Math.ceil(Math.max(width, height) * 1.12),
          cropped = document.createElement("canvas");
        cropped.width = size;
        cropped.height = size;
        cropped
          .getContext("2d")
          .drawImage(
            canvas,
            cellX + left,
            cellY + top,
            width,
            height,
            (size - width) / 2,
            (size - height) / 2,
            width,
            height,
          );
        art[name] = cropped.toDataURL("image/png");
      });
      navArtCache[theme] = art;
      if (document.body.dataset.theme === theme) applyNavigationArt(theme);
    };
    image.src = navArtSources[theme] || navClean;
  }
  prepareNavigationArt();
  function wireEditable() {
    $$(".task-line").forEach((row) => {
      row.style.cursor = "pointer";
      row.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        api.openEditor("Task", row);
      });
    });
    $$(".routine-card").forEach((card) =>
      card.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        api.openEditor("Routine", card);
      }),
    );
    $$(".exception").forEach((row) =>
      row.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        api.openEditor("Work", row);
      }),
    );
    $$(".library-note").forEach((note) => {
      note.style.cursor = "pointer";
      note.addEventListener("click", () => openNote(note));
    });
  }
  function openNote(note) {
    api.openEditor("Note", note);
    const f = api.form.elements;
    f.title.value = $("h3", note)?.textContent || "";
    f.notes.value = $("p", note)?.textContent || "";
    api.form.onsubmit = (e) => {
      e.preventDefault();
      $("h3", note).textContent = f.title.value;
      $("p", note).textContent = f.notes.value;
      api.persist();
      api.closeEditor();
      api.form.onsubmit = null;
    };
  }
  wireEditable();

  // Margin tasks and notes edit in place, so the planner stays calm and contextual.
  function wireMarginEditors() {
    $$(".margin .check-row").forEach((row) => {
      if ($(".margin-edit", row)) return;
      const button = document.createElement("button");
      button.className = "margin-edit";
      button.type = "button";
      button.setAttribute("aria-label", "Edit margin task");
      button.title = "Edit task";
      button.textContent = "✎";
      row.appendChild(button);
      button.onclick = (e) => {
        e.stopPropagation();
        openMarginEdit(row, "task");
      };
    });
    $$(".margin .note-card").forEach((note) => {
      if (!$(".margin-note-text", note)) {
        const wrap = document.createElement("span");
        wrap.className = "margin-note-text";
        while (note.firstChild) wrap.appendChild(note.firstChild);
        note.appendChild(wrap);
      }
      if ($(".margin-edit", note)) return;
      const button = document.createElement("button");
      button.className = "margin-edit";
      button.type = "button";
      button.setAttribute("aria-label", "Edit margin note");
      button.title = "Edit note";
      button.textContent = "✎";
      note.appendChild(button);
      button.onclick = (e) => {
        e.stopPropagation();
        openMarginEdit(note, "note");
      };
    });
  }
  function openMarginEdit(target, type) {
    if ($(".margin-inline-editor", target)) return;
    const content =
      type === "task"
        ? $(".task-text", target)
        : $(".margin-note-text", target);
    if (!content) return;
    const title =
      type === "task"
        ? [...content.childNodes]
            .filter((n) => n.nodeType === 3)
            .map((n) => n.textContent)
            .join("")
            .trim()
        : content.innerText.trim();
    const detail =
      type === "task" ? $("small", content)?.textContent || "" : "";
    content.hidden = true;
    const editor = document.createElement("form");
    editor.className = "margin-inline-editor";
    editor.innerHTML =
      type === "task"
        ? `<input name="title" aria-label="Task name" value="${esc(title)}" required><input name="detail" aria-label="Task timing or details" value="${esc(detail)}"><div><button type="submit">Save</button><button type="button" data-cancel>Cancel</button></div>`
        : `<textarea name="title" aria-label="Note text" rows="4" required>${esc(title)}</textarea><div><button type="submit">Save</button><button type="button" data-cancel>Cancel</button></div>`;
    target.appendChild(editor);
    const input = editor.elements.title;
    input.focus();
    input.select?.();
    const close = () => {
      content.hidden = false;
      editor.remove();
    };
    $("[data-cancel]", editor).onclick = close;
    editor.onsubmit = (e) => {
      e.preventDefault();
      const value = input.value.trim();
      if (!value) return;
      if (type === "task") {
        const small = $("small", content);
        [...content.childNodes]
          .filter((n) => n.nodeType === 3)
          .forEach((n) => n.remove());
        content.insertBefore(document.createTextNode(value), small || null);
        if (small) small.textContent = editor.elements.detail.value.trim();
      } else content.textContent = value;
      close();
      api.persist();
      flash(type === "task" ? "Margin task updated" : "Margin note updated");
    };
  }
  wireMarginEditors();
  // Newly created cards are wired at creation time; no DOM observer is needed here.

  // Shopping has a first-class attached checklist.
  const shoppingField = document.createElement("label");
  shoppingField.className = "shopping-field";
  shoppingField.innerHTML =
    'Shopping list<textarea name="shopping" rows="5" placeholder="One item per line"></textarea>';
  api.form.insertBefore(shoppingField, $(".editor-actions", api.form));
  shoppingField.style.display = "none";
  $$(".add-menu button").forEach((b) =>
    b.addEventListener("click", () => {
      shoppingField.style.display =
        b.dataset.type === "Shopping" ? "grid" : "none";
    }),
  );
  const originalOpen = api.openEditor;
  api.openEditor = (type, target) => {
    originalOpen(type, target);
    // A new item must not inherit date, time, notes, or repeat settings from
    // whichever existing item was edited last.  Reset only creation forms;
    // persisted-item helpers fill their saved values immediately afterward.
    if (!target) {
      const form = api.form.elements;
      form.date.value = dateKey(new Date());
      if (form.endDate) form.endDate.value = form.date.value;
      form.timing.value = "Exact time";
      form.start.value = "09:00";
      form.end.value = "10:00";
      form.notes.value = "";
      if (form.recurrence) form.recurrence.value = "none";
      if (form.status) form.status.value = "confirmed";
    }
    shoppingField.style.display = type === "Shopping" ? "grid" : "none";
    if (type === "Shopping")
      api.form.elements.shopping.value = target?.dataset.list || "";
  };
  $$(".item.shopping").forEach(
    (i) => (i.onclick = () => api.openEditor("Shopping", i)),
  );
  api.form.addEventListener("submit", () => {
    if (shoppingField.style.display === "none") return;
    const list = api.form.elements.shopping.value;
    queueMicrotask(() => {
      const target = api.editing || $$(".item.shopping").at(-1);
      if (target) {
        target.dataset.list = list;
        const count = list.split(/\n/).filter(Boolean).length;
        const meta = $("small", target);
        if (meta && count)
          meta.textContent = `${meta.textContent.split(" · ")[0]} · ${count} list items`;
        api.persist();
      }
    });
  });

  // Scheduling fields shared by events, tasks, routines, work, and shopping.
  const scheduleFields = document.createElement("div");
  scheduleFields.className = "schedule-fields";
  scheduleFields.innerHTML =
    '<div class="form-row"><label>Status<select name="status"><option value="confirmed">Confirmed</option><option value="penciled">Penciled in</option></select></label><label>Repeats<select name="recurrence"><option value="none">Does not repeat</option><option value="daily">Daily</option><option value="weekly">Weekly</option><option value="monthly">Monthly</option><option value="flexible">Flexible target</option></select></label></div><div class="conflict-box" hidden></div>';
  api.form.insertBefore(scheduleFields, shoppingField);
  // Events are real ranges: an end date can be the same day or far in the
  // future, and all-day ranges do not require invented start/end times.
  const endDateField = document.createElement("div");
  endDateField.className = "form-row date-range-field";
  endDateField.innerHTML = '<label>End date<input name="endDate" type="date"></label><small>Use the same date for a one-day event.</small>';
  api.form.insertBefore(endDateField, scheduleFields);
  const colorField = document.createElement("div");
  colorField.className = "form-row event-color-field";
  colorField.innerHTML = '<label>Event color<input name="color" type="color" value="#5f8c7c"></label><button type="button" data-clear-event-color>Use category style</button>';
  api.form.insertBefore(colorField, scheduleFields);
  const colorInput = api.form.elements.color;
  colorInput.addEventListener("input", () => (colorInput.dataset.custom = "true"));
  $("[data-clear-event-color]", colorField).onclick = () => {
    colorInput.dataset.custom = "false";
    flash("Using the category’s default style");
  };
  // A newly created event begins as a one-day range. When its start date is
  // changed, keep that default end date in step until the person explicitly
  // chooses a different end date for a real multi-day event.
  api.form.elements.date.addEventListener("change", () => {
    const date = api.form.elements.date,
      endDate = api.form.elements.endDate,
      previous = date.dataset.previousValue;
    if (!api.editing && (!endDate.value || endDate.value === previous))
      endDate.value = date.value;
    date.dataset.previousValue = date.value;
  });
  if (![...api.form.elements.timing.options].some((option) => option.value === "All day")) {
    const option = document.createElement("option");
    option.value = "All day";
    option.textContent = "All day";
    api.form.elements.timing.append(option);
  }
  const timeFieldLabels = [api.form.elements.start.closest("label"), api.form.elements.end.closest("label")].filter(Boolean);
  const updateAllDayFields = () => {
    const allDay = api.form.elements.timing.value === "All day";
    timeFieldLabels.forEach((label) => (label.hidden = allDay));
  };
  api.form.elements.timing.addEventListener("change", updateAllDayFields);
  const enhancedOpen = api.openEditor;
  api.openEditor = (type, target) => {
    api.form.onsubmit = null;
    enhancedOpen(type, target);
    const f = api.form.elements;
    f.status.value = target?.classList.contains("pencil")
      ? "penciled"
      : "confirmed";
    f.recurrence.value = target?.dataset.recurrence || "none";
    const m = target?.dataset.date;
    // New scheduled records start in the week the person is actively viewing
    // instead of inheriting the prototype's stale seed date.
    f.date.value = m || dateKey(activeWeekStart());
    f.endDate.value = target?.dataset.endDate || f.date.value;
    f.date.dataset.previousValue = f.date.value;
    if (target?.dataset.allDay === "true") f.timing.value = "All day";
    const savedColor = validEventColor(target?.dataset.color);
    f.color.value = savedColor || "#5f8c7c";
    f.color.dataset.custom = savedColor ? "true" : "false";
    f.start.value = target?.dataset.start || f.start.value;
    f.end.value = target?.dataset.end || f.end.value;
    updateAllDayFields();
    $(".conflict-box", api.form).hidden = true;
  };
  $$(".item").forEach(
    (i) =>
      (i.onclick = () =>
        api.openEditor(
          i.classList.contains("task")
            ? "Task"
            : i.classList.contains("routine")
              ? "Routine"
              : i.classList.contains("shopping")
                ? "Shopping"
                : "Event",
          i,
        )),
  );

  // The original prototype handled this form independently on every page.
  // Capture it before those legacy listeners so scheduled tasks, routines,
  // work, shopping, and events all write through the same cloud record.
  api.form.addEventListener(
    "submit",
    async (event) => {
      const type = api.currentType;
      if (
        !currentUser?.cloud ||
        !["Event", "Task", "Routine", "Work", "Shopping", "Note"].includes(type)
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = api.form.elements,
        title = (form.title.value || "").trim();
      if (!title) return;
      const target = api.editing,
        date = form.date.value,
        endDate = form.endDate?.value || date,
        start = form.start.value || "09:00",
        end = form.end.value || "10:00";
      if (endDate < date) {
        flash("End date must be on or after the start date.");
        return;
      }
      const kinds = {
        Event: "event",
        Task: "task",
        Routine: "routine",
        Work: "work",
        Shopping: "shopping",
        Note: "note",
      };
      const recurrence =
          form.recurrence?.value && form.recurrence.value !== "none"
            ? { frequency: form.recurrence.value }
            : {},
        color = form.color?.dataset.custom === "true" ? validEventColor(form.color.value) : "",
        details = {
          provider: "guardian",
          guardian_dirty: true,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago",
          notes: form.notes.value || "",
          recurrence,
          ...(color ? { color } : {}),
        };
      const button = $('button[type="submit"]', api.form);
      if (button) {
        button.disabled = true;
        button.textContent = "Saving…";
      }
      try {
        const saved = await window.guardianCloud.saveItem({
          ...(target?.dataset.cloudId ? { id: target.dataset.cloudId } : {}),
          kind: kinds[type],
          title,
          starts_at: new Date(`${date}T${form.timing.value === "All day" ? "00:00:00" : `${start}:00`}`).toISOString(),
          ends_at: new Date(`${endDate}T${form.timing.value === "All day" ? "23:59:59.999" : `${end}:00`}`).toISOString(),
          timing_precision:
            form.timing.value === "All day"
              ? "date-only"
              : form.timing.value === "Exact time"
                ? "exact"
                : "sometime",
          status: form.status.value || "confirmed",
          recurrence,
          details,
        });
        if (type === "Task") {
          let row = target;
          if (!row || !row.classList.contains("task-line")) {
            row = document.createElement("div");
            row.className = "task-line";
            $("#page-tasks .content-card")?.insertBefore(
              row,
              $("#page-tasks .section-bar"),
            );
          }
          const taskStart = new Date(saved.starts_at),
            taskEnd = new Date(saved.ends_at || taskStart.getTime() + 3600000);
          row.dataset.cloudId = saved.id;
          row.dataset.date = dateKey(taskStart);
          row.dataset.start = `${String(taskStart.getHours()).padStart(2, "0")}:${String(taskStart.getMinutes()).padStart(2, "0")}`;
          row.dataset.end = `${String(taskEnd.getHours()).padStart(2, "0")}:${String(taskEnd.getMinutes()).padStart(2, "0")}`;
          row.dataset.recurrence = saved.recurrence?.frequency || "none";
          row.dataset.notes = form.notes.value || "";
          row.dataset.color = color;
          row.innerHTML = `<button class="round-check"></button><div><strong>${esc(title)}</strong><small>${esc(form.timing.value || "Anytime")} · ${esc(form.notes.value || "scheduled task")}</small></div><span class="tag sage">scheduled</span><button class="ghost">Schedule</button>`;
          row.onclick = (click) => {
            if (!click.target.closest("button")) api.openEditor("Task", row);
          };
        }
        if (type === "Note") {
          let note = target;
          if (!note || !note.classList.contains("library-note")) {
            note = document.createElement("article");
            note.className = "library-note";
            $(".notes-grid")?.prepend(note);
          }
          note.dataset.cloudId = saved.id;
          note.innerHTML = `<small>NOTE</small><h3>${esc(title)}</h3><p>${esc(form.notes.value || "")}</p><footer>Saved to your account</footer>`;
          note.onclick = () => openNote(note);
        }
        if (type === "Routine") {
          let card = target;
          if (!card || !card.classList.contains("routine-card")) {
            card = document.createElement("article");
            card.className = "routine-card";
            $(".routine-grid")?.prepend(card);
          }
          card.dataset.cloudId = saved.id;
          card.innerHTML = `<div class="routine-symbol">○</div><span class="tag sage">${esc(form.recurrence?.value || "weekly")}</span><h3>${esc(title)}</h3><p>${esc(form.timing.value || "Anytime")} · ${esc(form.notes.value || "")}</p><div class="week-dots"><i>M</i><i>T</i><i>W</i><i>T</i><i>F</i><i>S</i><i>S</i></div><button class="wide-ghost">Mark complete</button>`;
          card.onclick = (click) => {
            if (!click.target.closest("button"))
              api.openEditor("Routine", card);
          };
        }
        if (type === "Work") {
          let row = target;
          if (!row || !row.classList.contains("exception")) {
            row = document.createElement("div");
            row.className = "exception";
            $("#page-work .content-card")?.append(row);
          }
          row.dataset.cloudId = saved.id;
          row.innerHTML = `<span class="date-box"><b>${esc(String(date).slice(-2))}</b>${esc(new Date(`${date}T12:00`).toLocaleString("en", { month: "short" }).toUpperCase())}</span><div><strong>${esc(title)}</strong><small>${esc(start)}–${esc(end)} · ${esc(form.notes.value || "work exception")}</small></div><span class="tag blue">adjusted</span>`;
          row.onclick = (click) => {
            if (!click.target.closest("button")) api.openEditor("Work", row);
          };
        }
        if (target) target.dataset.cloudId = saved.id;
        await window.guardianCloud.pushPlannerItem(saved.id).catch(() => null);
        await refreshCloudPlannerItems();
        api.closeEditor();
        flash(`${type} saved across Calendar Guardian`);
      } catch (error) {
        flash(error?.message || `Unable to save this ${type.toLowerCase()}.`);
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = "Save changes";
        }
      }
    },
    true,
  );

  // Seed exact times on existing cards so conflicts work immediately.
  $$(".week-grid .day").forEach((day, dayIndex) =>
    $$(".item", day).forEach((item) => {
      item.dataset.date = `2026-08-${String(24 + dayIndex).padStart(2, "0")}`;
      const text = $("small", item)?.textContent || "";
      const match = text.match(
        /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?[–-](\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i,
      );
      if (match) {
        const late = (parseFloat(item.style.top) || 0) > 40;
        const cv = (h, m, ap) => {
          h = +h;
          if (ap?.toLowerCase() === "pm" && h < 12) h += 12;
          if (ap?.toLowerCase() === "am" && h === 12) h = 0;
          if (!ap && late && h < 9) h += 12;
          return {
            h,
            m: m || "00",
            text: `${String(h).padStart(2, "0")}:${m || "00"}`,
          };
        };
        const start = cv(match[1], match[2], match[3] || match[6]),
          end = cv(match[4], match[5], match[6] || match[3]);
        if (end.h < start.h) end.h += 12;
        item.dataset.start = start.text;
        item.dataset.end = `${String(end.h).padStart(2, "0")}:${end.m}`;
      }
    }),
  );
  api.form.addEventListener(
    "submit",
    (e) => {
      const f = api.form.elements;
      if (!["Event", "Shopping", "Task", "Routine"].includes(api.currentType))
        return;
      const exact = f.timing.value === "Exact time";
      const day =
        $$(".week-grid .day")[
          (parseInt(f.date.value.slice(-2), 10) - 24 + 7) % 7
        ];
      const peers = day
        ? $$(".item", day).filter((i) => i !== api.editing)
        : [];
      const overlaps = exact
        ? peers.filter(
            (i) =>
              i.dataset.start &&
              f.start.value < i.dataset.end &&
              f.end.value > i.dataset.start,
          )
        : [];
      const box = $(".conflict-box", api.form);
      if (
        f.status.value === "confirmed" &&
        overlaps.some((i) => i.classList.contains("confirmed"))
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        box.hidden = false;
        box.innerHTML =
          "<strong>That time already has a confirmed event.</strong><span>Choose a different time or save this as penciled in.</span>";
        return;
      }
      box.hidden = true;
      const edited = api.editing;
      const type = api.currentType;
      const savedTitle = f.title.value.trim();
      const data = {
        date: f.date.value,
        start: f.start.value,
        end: f.end.value,
        status: f.status.value,
        recurrence: f.recurrence.value,
        timing: f.timing.value,
      };
      queueMicrotask(() => {
        let target = edited;
        if (!target && ["Event", "Shopping", "Routine"].includes(type))
          target = $$(".week-grid .item").find(
            (i) =>
              (i.querySelector("strong")?.textContent || "").replace(
                /^[▱]\s*/,
                "",
              ) === savedTitle,
          );
        if (target) {
          Object.assign(target.dataset, data);
          target.classList.toggle("pencil", data.status === "penciled");
          target.classList.toggle(
            "confirmed",
            data.status === "confirmed" && type === "Event",
          );
          if (day && target.closest(".day") !== day) day.appendChild(target);
          if (exact) {
            const mins =
              parseInt(data.start) * 60 +
              parseInt(data.start.slice(3)) -
              7 * 60;
            target.style.top = `${Math.max(0, Math.min(92, (mins / (12 * 60)) * 100))}%`;
          } else
            target.style.top =
              data.timing === "Morning"
                ? "4%"
                : data.timing === "Afternoon"
                  ? "45%"
                  : data.timing === "Evening"
                    ? "72%"
                    : "2%";
          overlaps
            .filter((i) => i.classList.contains("pencil"))
            .forEach((i) => i.classList.add("conflict-bumped"));
          api.persist();
        }
      });
    },
    true,
  );

  // View switching: Week is the full planner; Day/Month/Agenda are useful alternate reads of the same items.
  const planner = $(".planner"),
    calendar = $(".calendar");
  // A mobile pinch/fit measurement is intentionally stored inline while the
  // phone view is open. Never carry those measurements into desktop: doing so
  // creates seven columns for the time lane plus seven days and wraps Sunday.
  if (innerWidth > 800) {
    [".week-grid", ".day-heads"].forEach((selector) => {
      const element = $(selector, calendar);
      element?.style.removeProperty("grid-template-columns");
    });
    [".calendar", ".week-grid", ".day-heads"].forEach((selector) => {
      const element = $(selector, calendar);
      element?.style.removeProperty("width");
      element?.style.removeProperty("min-width");
    });
  }
  // Keep an untouched week shell. Cloud records are rendered into that shell
  // for the week the person is actually looking at; they must never become a
  // stale snapshot baked into the next/previous-week controls.
  let weekMarkup = calendar.innerHTML;
  function items() {
    return $$(".week-grid .item").map((el, i) => ({
      title: $("strong", el)?.textContent || "",
      meta: $("small", el)?.textContent || "",
      kind: el.classList.contains("pencil")
        ? "penciled"
        : el.classList.contains("task")
          ? "task"
          : el.classList.contains("routine")
            ? "routine"
            : el.classList.contains("shopping")
              ? "shopping"
              : "confirmed",
      day: Math.max(0, $$(".day").indexOf(el.closest(".day"))),
      date: el.dataset.date || "",
      recurrence: el.dataset.recurrence || "none",
      top: parseFloat(el.style.top) || 20,
      cloudId: el.dataset.cloudId || "",
      html: el.outerHTML,
      index: i,
    }));
  }
  let calendarRecords = items();
  let cloudPlannerRecords = [];
  const names = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const startOfWeek = (value) => {
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - ((date.getDay() + 6) % 7));
    return date;
  };
  let currentView = "week",
    monthCursor = new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    weekOffset = 0;
  const dateKey = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const activeWeekStart = () => {
    const date = startOfWeek(new Date());
    date.setDate(date.getDate() + weekOffset * 7);
    return date;
  };
  const dayDistance = (value, start = activeWeekStart()) => {
    const date = new Date(value);
    const local = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.round((local - start) / 86400000);
  };
  // Google represents all-day end dates as exclusive; Guardian stores the
  // person's selected end date as inclusive. Normalize either form before we
  // project a range into the individual calendar days it covers.
  const inclusiveRangeEnd = (record) => {
    const start = new Date(record.starts_at), end = new Date(record.ends_at || record.starts_at);
    if (
      record.timing_precision === "date-only" &&
      end > start &&
      end.getHours() === 0 && end.getMinutes() === 0 && end.getSeconds() === 0
    ) end.setDate(end.getDate() - 1);
    return end;
  };
  const rangeEndDateKey = (record) => dateKey(inclusiveRangeEnd(record));
  const projectDateRange = (entry, start, end) => {
    const record = entry.record, first = new Date(record.starts_at), last = inclusiveRangeEnd(record);
    first.setHours(0, 0, 0, 0);
    last.setHours(0, 0, 0, 0);
    const segments = [];
    for (const cursor = new Date(first); cursor <= last; cursor.setDate(cursor.getDate() + 1)) {
      if (cursor < start || cursor >= end) continue;
      const key = dateKey(cursor), isFirst = key === dateKey(new Date(record.starts_at)), isLast = key === rangeEndDateKey(record);
      const displayStart = record.timing_precision === "date-only"
        ? new Date(`${key}T00:00:00`)
        : isFirst ? new Date(record.starts_at) : new Date(`${key}T07:00:00`);
      const displayEnd = record.timing_precision === "date-only"
        ? new Date(`${key}T23:59:59.999`)
        : isLast ? new Date(record.ends_at || record.starts_at) : new Date(`${key}T19:00:00`);
      segments.push({ ...entry, date: key, day: dayDistance(cursor), displayStartsAt: displayStart.toISOString(), displayEndsAt: displayEnd.toISOString() });
    }
    return segments;
  };
  function refreshCalendarRecords(includeAll = false) {
    const local = items().filter((record) => !record.cloudId);
    const rangeStart = includeAll
        ? new Date(monthCursor.getFullYear(), monthCursor.getMonth(), 1)
        : activeWeekStart(),
      rangeEnd = includeAll
        ? new Date(monthCursor.getFullYear(), monthCursor.getMonth() + 1, 1)
        : new Date(rangeStart.getTime() + 7 * 86400000),
      advance = (date, frequency) => {
        const next = new Date(date);
        if (frequency === "daily") next.setDate(next.getDate() + 1);
        else if (frequency === "monthly") next.setMonth(next.getMonth() + 1);
        else next.setDate(next.getDate() + 7);
        return next;
      },
      cloud = cloudPlannerRecords
        .flatMap((entry) => {
          const record = entry.record,
            frequency = record.recurrence?.frequency,
            repeatingSeries = ["daily", "weekly", "monthly"].includes(
              frequency,
            );
          if (!repeatingSeries) return projectDateRange(entry, rangeStart, rangeEnd);
          const originalStart = new Date(record.starts_at),
            originalEnd = record.ends_at ? new Date(record.ends_at) : null,
            duration = originalEnd
              ? originalEnd.getTime() - originalStart.getTime()
              : 3600000,
            occurrences = [];
          let occurrence = new Date(originalStart);
          while (occurrence < rangeStart)
            occurrence = advance(occurrence, frequency);
          while (occurrence < rangeEnd) {
            const occurrenceRecord = {
              ...record,
              starts_at: occurrence.toISOString(),
              ends_at: new Date(occurrence.getTime() + duration).toISOString(),
            };
            occurrences.push({
              ...entry,
              record: occurrenceRecord,
            });
            occurrence = advance(occurrence, frequency);
          }
          return occurrences.flatMap((occurrence) => projectDateRange(occurrence, rangeStart, rangeEnd));
        })
        .filter((record) => includeAll || (record.day >= 0 && record.day < 7));
    calendarRecords = [...local, ...cloud];
    return calendarRecords;
  }
  function renderCloudWeek() {
    if (!$(".week-grid", calendar)) return;
    $$(".item[data-cloud-item]", calendar).forEach((item) => item.remove());
    const dayNodes = $$(".week-grid .day", calendar);
    refreshCalendarRecords()
      .filter((record) => record.day >= 0 && record.day < 7)
      .forEach((entry) => {
        const record = entry.record,
          begins = new Date(entry.displayStartsAt || record.starts_at),
          ends = entry.displayEndsAt
            ? new Date(entry.displayEndsAt)
            : record.ends_at
            ? new Date(record.ends_at)
            : new Date(begins.getTime() + 3600000),
          duration = Math.max(30, Math.round((ends - begins) / 60000)),
          top = Math.max(
            1,
            Math.min(
              92,
              ((begins.getHours() * 60 + begins.getMinutes() - 420) / 720) *
                100,
            ),
          ),
          height = Math.max(5, Math.min(28, (duration / 720) * 100));
        const card = document.createElement("div"),
          kind = entry.kind;
        card.className = `item ${kind} cloud-item`;
        card.dataset.cloudItem = "true";
        card.dataset.cloudId = record.id;
        card.dataset.date = entry.date;
        card.dataset.endDate = rangeEndDateKey(record);
        card.dataset.allDay = record.timing_precision === "date-only" ? "true" : "false";
        card.dataset.color = validEventColor(record.details?.color);
        card.dataset.recurrence = record.recurrence?.frequency || "none";
        card.dataset.start = `${String(begins.getHours()).padStart(2, "0")}:${String(begins.getMinutes()).padStart(2, "0")}`;
        card.dataset.end = `${String(ends.getHours()).padStart(2, "0")}:${String(ends.getMinutes()).padStart(2, "0")}`;
        const color = validEventColor(record.details?.color);
        card.classList.toggle("custom-color", Boolean(color));
        card.style.cssText = `top:${top}%;height:${height}%;${color ? `--event-color:${color}` : ""}`;
        card.innerHTML = `<strong>${kind === "task" ? "□ " : kind === "shopping" ? "▱ " : ""}${esc(record.title)}</strong><small>${esc(entry.meta)}</small>`;
        dayNodes[entry.day]?.append(card);
      });
    bindCalendarItems();
    wireDrag();
  }
  function syncWeekShell() {
    const base = activeWeekStart(),
      end = new Date(base);
    end.setDate(base.getDate() + 6);
    const beginMonth = base.toLocaleString("en", { month: "long" }),
      endMonth = end.toLocaleString("en", { month: "long" });
    headerTitle.textContent =
      beginMonth === endMonth
        ? `${beginMonth} ${base.getDate()}–${end.getDate()}`
        : `${beginMonth} ${base.getDate()}–${endMonth} ${end.getDate()}`;
    $$(".day-head", calendar).forEach((head, index) => {
      const date = new Date(base);
      date.setDate(date.getDate() + index);
      const number = $("strong", head),
        weekday = $("small", head);
      if (number) number.textContent = String(date.getDate());
      if (weekday) weekday.textContent = names[index].slice(0, 3).toUpperCase();
    });
  }
  function week() {
    currentView = "week";
    calendar.innerHTML = weekMarkup;
    if (currentUser?.cloud) clearCloudWorkPlaceholders();
    calendar.className = "calendar";
    syncWeekShell();
    renderCloudWeek();
    $$(".day-head", calendar).forEach(
      (head, i) =>
        (head.onclick = () => {
          day();
          const d = new Date(activeWeekStart());
          d.setDate(d.getDate() + i);
          $(".alt-head h2").textContent =
            `${names[i]} · ${d.toLocaleString("en", { month: "long", day: "numeric" })}`;
        }),
    );
    if (innerWidth < 800) planner.scrollLeft = 0;
    api.persist();
  }
  function day() {
    currentView = "day";
    const dayDate = new Date(activeWeekStart());
    dayDate.setDate(dayDate.getDate() + 1);
    headerTitle.textContent = dayDate.toLocaleString("en", {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
    const all = refreshCalendarRecords().filter((x) => x.day === 1);
    calendar.className = "calendar alternate-calendar";
    calendar.innerHTML = `<div class="alt-head"><div><span>${names[1].toUpperCase()}</span><h2>${dayDate.toLocaleString("en", { month: "long", day: "numeric" })}</h2></div><small>${all.length} items</small></div><div class="day-layout"><aside>${Array.from({ length: 13 }, (_, i) => `<span>${i + 7 > 12 ? i - 5 : i + 7}:00</span>`).join("")}</aside><div class="day-canvas">${all.map((x, index) => { const color = validEventColor(x.record?.details?.color); return `<button class="agenda-item ${x.kind} ${color ? "custom-color" : ""}" data-record-index="${index}" style="top:${Math.max(2, x.top)}%;${color ? `--event-color:${color}` : ""}"><strong>${esc(x.title)}</strong><small>${esc(x.meta)}</small></button>`; }).join("")}</div><aside class="day-margin"><h3>Tuesday margin</h3>${$$(
      ".check-row",
    )
      .slice(0, 3)
      .map((x) => `<div>${esc(x.innerText)}</div>`)
      .join("")}</aside></div>`;
    bindAltItems(all);
  }
  function month() {
    currentView = "month";
    const all = refreshCalendarRecords(true),
      year = monthCursor.getFullYear(),
      monthIndex = monthCursor.getMonth(),
      first = new Date(year, monthIndex, 1),
      offset = (first.getDay() + 6) % 7,
      start = new Date(year, monthIndex, 1 - offset),
      monthLabel = first.toLocaleString("en", {
        month: "long",
        year: "numeric",
      }),
      today = dateKey(new Date());
    // Give each overlapping item a stable lane. A multi-day item then uses
    // the same vertical lane in every covered cell, which makes it read as a
    // continuous calendar ribbon instead of a new event on each date.
    const ranges = [...new Map(all.map((entry) => {
      const identity = `${entry.cloudId || entry.title}:${entry.record?.starts_at || entry.date}`;
      return [identity, {
        identity,
        start: dateKey(new Date(entry.record?.starts_at || entry.date)),
        end: entry.record ? rangeEndDateKey(entry.record) : entry.date,
      }];
    })).values()].sort((a, b) => a.start.localeCompare(b.start) || a.end.localeCompare(b.end));
    const laneEnds = [], rangeLanes = new Map();
    ranges.forEach((range) => {
      let lane = laneEnds.findIndex((end) => end < range.start);
      if (lane < 0) lane = laneEnds.length;
      laneEnds[lane] = range.end;
      rangeLanes.set(range.identity, lane);
    });
    const monthItem = (entry) => {
      const record = entry.record,
        rangeStart = dateKey(new Date(record?.starts_at || entry.date)),
        rangeEnd = record ? rangeEndDateKey(record) : entry.date,
        multiDay = rangeStart !== rangeEnd,
        identity = `${entry.cloudId || entry.title}:${record?.starts_at || entry.date}`,
        lane = rangeLanes.get(identity) || 0,
        isStart = entry.date === rangeStart,
        isEnd = entry.date === rangeEnd,
        weekday = (new Date(`${entry.date}T12:00:00`).getDay() + 6) % 7,
        rowStart = weekday === 0,
        rowEnd = weekday === 6,
        segment = !multiDay ? "" : isStart ? "range-start" : isEnd ? "range-end" : "range-middle",
        rowClass = multiDay ? `${rowStart && !isStart ? " range-row-start" : ""}${rowEnd && !isEnd ? " range-row-end" : ""}` : "",
        label = !multiDay || isStart || rowStart ? esc(entry.title) : "",
        color = validEventColor(record?.details?.color);
      return `<button class="month-item ${entry.kind} ${color ? "custom-color" : ""} ${multiDay ? `range-span ${segment}${rowClass}` : ""}" data-cloud-id="${esc(entry.cloudId || "")}" data-range-segment="${multiDay ? "true" : "false"}" aria-label="${esc(entry.title)}" style="--month-lane:${lane};${color ? `--event-color:${color}` : ""}">${label}</button>`;
    };
    const cells = Array.from({ length: 42 }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      const key = dateKey(d),
        its = all.filter((x) => x.date === key).sort((a, b) => {
          const aKey = `${a.cloudId || a.title}:${a.record?.starts_at || a.date}`,
            bKey = `${b.cloudId || b.title}:${b.record?.starts_at || b.date}`;
          return (rangeLanes.get(aKey) || 0) - (rangeLanes.get(bKey) || 0);
        }),
        outside = d.getMonth() !== monthIndex;
      return `<article class="month-day ${outside ? "outside-month" : ""} ${key === today ? "today-cell" : ""}" data-date="${key}"><b>${d.getDate()}</b>${its.map(monthItem).join("")}</article>`;
    }).join("");
    const visible = all.filter((x) =>
      x.date.startsWith(`${year}-${String(monthIndex + 1).padStart(2, "0")}-`),
    ).length;
    headerTitle.textContent = monthLabel;
    calendar.className = "calendar alternate-calendar";
    calendar.innerHTML = `<div class="alt-head"><div><span>${monthLabel.toUpperCase()}</span><h2>${monthLabel}</h2></div><small>${visible} scheduled items</small></div><div class="month-grid">${names.map((n) => `<div class="month-weekday">${n.slice(0, 3)}</div>`).join("")}${cells}</div>`;
    bindAltItems(all);
  }
  function agenda() {
    currentView = "agenda";
    headerTitle.textContent = "Agenda";
    const all = [...refreshCalendarRecords()].sort(
        (a, b) => a.day - b.day || a.top - b.top,
      ),
      start = activeWeekStart();
    calendar.className = "calendar alternate-calendar";
    calendar.innerHTML = `<div class="alt-head"><div><span>NEXT 7 DAYS</span><h2>Agenda</h2></div><small>Everything, in order</small></div><div class="agenda-list">${names
      .map((name, d) => {
        const date = new Date(start);
        date.setDate(date.getDate() + d);
        return `<section><header><b>${name}</b><span>${date.getDate()}</span></header>${
          all
            .filter((x) => x.day === d)
            .map(
              (x) =>
                `<button class="agenda-row ${validEventColor(x.record?.details?.color) ? "custom-color" : ""}" data-record-index="${all.indexOf(x)}" style="${validEventColor(x.record?.details?.color) ? `--event-color:${validEventColor(x.record.details.color)}` : ""}"><i class="${x.kind}"></i><span><strong>${esc(x.title)}</strong><small>${esc(x.meta)}</small></span></button>`,
            )
            .join("") || "<p>Open space</p>"
        }</section>`;
      })
      .join("")}</div>`;
    bindAltItems(all);
  }
  function bindCalendarItems() {
    $$(".item", calendar).forEach(
      (i) =>
        (i.onclick = () =>
          api.openEditor(
            i.classList.contains("task")
              ? "Task"
              : i.classList.contains("routine")
                ? "Routine"
                : i.classList.contains("shopping")
                  ? "Shopping"
                  : "Event",
            i,
          )),
    );
  }
  function bindAltItems(records = []) {
    const byCloudId = new Map(
      records.filter((entry) => entry.cloudId).map((entry) => [entry.cloudId, entry]),
    );
    const openRecord = (entry) => {
      if (!entry?.record?.id) return;
      const record = entry.record,
        start = new Date(record.starts_at),
        end = new Date(record.ends_at || start.getTime() + 3600000),
        proxy = document.createElement("div"),
        type = entry.kind === "task" ? "Task" : entry.kind === "routine" ? "Routine" : entry.kind === "shopping" ? "Shopping" : entry.kind === "work" ? "Work" : "Event";
      proxy.className = `item ${entry.kind}`;
      proxy.dataset.cloudId = record.id;
      proxy.dataset.date = dateKey(start);
      proxy.dataset.endDate = rangeEndDateKey(record);
      proxy.dataset.allDay = record.timing_precision === "date-only" ? "true" : "false";
      proxy.dataset.color = validEventColor(record.details?.color);
      proxy.dataset.start = `${String(start.getHours()).padStart(2, "0")}:${String(start.getMinutes()).padStart(2, "0")}`;
      proxy.dataset.end = `${String(end.getHours()).padStart(2, "0")}:${String(end.getMinutes()).padStart(2, "0")}`;
      proxy.dataset.recurrence = record.recurrence?.frequency || "none";
      proxy.dataset.notes = record.details?.notes || "";
      proxy.innerHTML = `<strong>${esc(record.title)}</strong><small>${esc(record.details?.notes || "")}</small>`;
      api.openEditor(type, proxy);
    };
    $$("[data-record-index]", calendar).forEach((button) => {
      button.onclick = () => openRecord(records[Number(button.dataset.recordIndex)]);
    });
    $$("[data-cloud-id]", calendar).forEach((button) => {
      button.onclick = () => openRecord(byCloudId.get(button.dataset.cloudId));
    });
  }
  // Margin is a drawer control, not a calendar view. Keep it out of the
  // view-selection path so tapping it cannot change the selected layout.
  const calendarViewButtons = $$(
    ".view .ctl:not(.fit):not(.mobile-margin-toggle)",
  );
  const selectCalendarView = (button) =>
    $$(".view .ctl:not(.fit):not(.mobile-margin-toggle)").forEach((candidate) =>
      candidate.classList.toggle("active", candidate === button),
    );
  calendarViewButtons.forEach((button) =>
    button.addEventListener("click", () => {
      if (button.textContent === "Week") week();
      else if (button.textContent === "Day") day();
      else if (button.textContent === "Month") month();
      else if (button.textContent === "Agenda") agenda();
      selectCalendarView(button);
    }),
  );
  const mobileFit = $(".fit");
  mobileFit?.remove();
  if (innerWidth <= 800) {
    let calendarScale = 1,
      pinchStart = 0,
      pinchBase = 1,
      queuedScale = 0,
      frame = 0,
      panStart = null;
    const distance = (touches) =>
        Math.hypot(
          touches[0].clientX - touches[1].clientX,
          touches[0].clientY - touches[1].clientY,
        ),
      applyScale = (next) => {
        calendarScale = Math.max(1, Math.min(2.15, next));
        const available = planner.clientWidth,
          time = Math.round(28 * calendarScale),
          day = Math.round(((available - 28) / 7) * calendarScale),
          wide = calendarScale > 1.02;
        document.body.classList.toggle("mobile-calendar-fit", !wide);
        document.body.classList.toggle("mobile-calendar-scaled", wide);
        document.documentElement.style.setProperty(
          "--mobile-calendar-scale",
          calendarScale,
        );
        const columns = `${time}px repeat(7,${day}px)`,
          size = (element, property, value) =>
            element?.style.setProperty(property, value, "important"),
          alternate = $("#page-calendar .calendar.alternate-calendar"),
          monthGrid = $("#page-calendar .month-grid"),
          weekGrid = $("#page-calendar .week-grid"),
          dayHeads = $("#page-calendar .day-heads");
        size(weekGrid, "grid-template-columns", columns);
        size(dayHeads, "grid-template-columns", columns);
        size($("#page-calendar .calendar"), "width", `${time + day * 7}px`);
        size($("#page-calendar .calendar"), "min-width", `${time + day * 7}px`);
        if (alternate && monthGrid) {
          const monthWidth = Math.round(available * calendarScale),
            monthDay = Math.max(42, Math.floor((monthWidth - 26) / 7));
          size(alternate, "width", `${monthWidth}px`);
          size(alternate, "min-width", `${monthWidth}px`);
          size(monthGrid, "grid-template-columns", `repeat(7,${monthDay}px)`);
          size(monthGrid, "width", `${monthDay * 7}px`);
          size(monthGrid, "min-width", `${monthDay * 7}px`);
        }
        if (!wide) {
          size(weekGrid, "grid-template-columns", "repeat(7,minmax(0,1fr))");
          size(dayHeads, "grid-template-columns", "repeat(7,minmax(0,1fr))");
          size($("#page-calendar .calendar"), "width", "100%");
          size($("#page-calendar .calendar"), "min-width", "0");
          if (alternate) {
            size(alternate, "width", "100%");
            size(alternate, "min-width", "0");
          }
          if (monthGrid) {
            size(monthGrid, "grid-template-columns", "repeat(7,minmax(0,1fr))");
            size(monthGrid, "width", "100%");
            size(monthGrid, "min-width", "0");
          }
        }
        planner.style.overflowX = wide ? "auto" : "hidden";
      };
    const scheduleScale = (value) => {
      queuedScale = value;
      if (!frame)
        frame = requestAnimationFrame(() => {
          frame = 0;
          applyScale(queuedScale);
        });
    };
    applyScale(1);
    planner.addEventListener(
      "touchstart",
      (event) => {
        if (event.touches.length === 2) {
          pinchStart = distance(event.touches);
          pinchBase = calendarScale;
          panStart = null;
        } else if (event.touches.length === 1 && calendarScale > 1.02) {
          const touch = event.touches[0];
          panStart = {
            x: touch.clientX,
            y: touch.clientY,
            left: planner.scrollLeft,
            top: planner.scrollTop,
          };
        }
      },
      { passive: true },
    );
    planner.addEventListener(
      "touchmove",
      (event) => {
        if (event.touches.length === 2 && pinchStart) {
          event.preventDefault();
          scheduleScale(pinchBase * (distance(event.touches) / pinchStart));
          return;
        }
        if (event.touches.length !== 1 || !panStart) return;
        const touch = event.touches[0],
          dx = touch.clientX - panStart.x,
          dy = touch.clientY - panStart.y;
        if (Math.abs(dx) > Math.abs(dy)) {
          event.preventDefault();
          planner.scrollLeft = panStart.left - dx;
          const alternate = $("#page-calendar .calendar.alternate-calendar");
          if (alternate) alternate.scrollLeft = panStart.left - dx;
        }
      },
      { passive: false },
    );
    planner.addEventListener(
      "touchend",
      (event) => {
        if (event.touches.length < 2) pinchStart = 0;
        if (!event.touches.length) panStart = null;
      },
      { passive: true },
    );
  }
  const agendaButton = document.createElement("button");
  agendaButton.className = "ctl";
  agendaButton.textContent = "Agenda";
  $(".view").appendChild(agendaButton);
  agendaButton.onclick = () => {
    agenda();
    selectCalendarView(agendaButton);
  };
  const marginButton = document.createElement("button");
  marginButton.className = "ctl mobile-margin-toggle";
  marginButton.type = "button";
  marginButton.textContent = "Margin";
  marginButton.setAttribute("aria-expanded", "false");
  $(".view").appendChild(marginButton);
  const plannerMargin = $(".margin", planner);
  let marginClose = $(".mobile-margin-close", plannerMargin);
  if (plannerMargin && !marginClose) {
    marginClose = document.createElement("button");
    marginClose.className = "mini-btn mobile-margin-close";
    marginClose.type = "button";
    marginClose.setAttribute("aria-label", "Close planner margin");
    marginClose.textContent = "×";
    const head = $(".margin-head", plannerMargin);
    head?.insertBefore(marginClose, $("button", head));
  }
  const setMarginOpen = (open) => {
    if (innerWidth <= 800) {
      plannerMargin?.classList.toggle("mobile-open", !!open);
      document.body.classList.toggle("mobile-margin-visible", !!open);
    } else {
      planner?.classList.toggle("desktop-margin-hidden", !open);
      prefs.plannerMargin = !!open;
      savePrefs();
    }
    marginButton.setAttribute("aria-expanded", String(!!open));
  };
  const closeMargin = () => setMarginOpen(false);
  marginButton.onclick = (e) => {
    e.stopPropagation();
    const open =
      innerWidth <= 800
        ? plannerMargin?.classList.contains("mobile-open")
        : !planner?.classList.contains("desktop-margin-hidden");
    setMarginOpen(!open);
  };
  marginClose?.addEventListener("click", closeMargin);
  $$(".view .ctl").forEach((button) => {
    if (button !== marginButton)
      button.addEventListener("click", () => {
        if (innerWidth <= 800) closeMargin();
      });
  });
  setMarginOpen(innerWidth > 800 ? prefs.plannerMargin !== false : false);
  const marginOptions = $(
    '.margin-head button[aria-label="Margin options"]',
    plannerMargin,
  );
  if (marginOptions) {
    const menu = document.createElement("div");
    menu.className = "margin-options-menu";
    menu.hidden = true;
    menu.innerHTML =
      '<button type="button" data-margin-mode="toggle">Hide planner margin</button><button type="button" data-margin-mode="settings">Margin settings</button>';
    plannerMargin?.append(menu);
    marginOptions.onclick = (event) => {
      event.stopPropagation();
      menu.hidden = !menu.hidden;
    };
    $('[data-margin-mode="toggle"]', menu).onclick = () => {
      setMarginOpen(false);
      menu.hidden = true;
    };
    $('[data-margin-mode="settings"]', menu).onclick = () => {
      api.showPage("settings");
      showSetting("calendar");
      menu.hidden = true;
    };
  }
  // Fit is bound in the base mobile shell so it remains reliable before optional enhancements load.

  // Week navigation, day opening, direct time creation, and drag scheduling.
  const headerTitle = $(".date-title h1");
  function shiftWeek(delta) {
    weekOffset += delta;
    syncWeekShell();
    if (currentView === "week") renderCloudWeek();
    else if (currentView === "agenda") agenda();
    else if (currentView === "day") day();
  }
  const dateControls =
    $$(".topbar .control-group").first?.() || $(".topbar .control-group");
  const dateButtons = $$("button", dateControls);
  if (dateButtons.length >= 3) {
    dateButtons[0].onclick = () => {
      if (currentView === "month") {
        monthCursor.setMonth(monthCursor.getMonth() - 1);
        month();
      } else shiftWeek(-1);
    };
    dateButtons[1].onclick = () => {
      if (currentView === "month") {
        const now = new Date();
        monthCursor = new Date(now.getFullYear(), now.getMonth(), 1);
        month();
      } else {
        weekOffset = 0;
        shiftWeek(0);
      }
    };
    dateButtons[2].onclick = () => {
      if (currentView === "month") {
        monthCursor.setMonth(monthCursor.getMonth() + 1);
        month();
      } else shiftWeek(1);
    };
  }
  $$(".day-head").forEach(
    (head, i) =>
      (head.onclick = () => {
        day();
        const date = new Date(activeWeekStart());
        date.setDate(date.getDate() + i);
        $(".alt-head h2").textContent =
          `${names[i]} · ${date.toLocaleString("en", { month: "long", day: "numeric" })}`;
      }),
  );
  let dragged = null;
  const weekDateForIndex = (index) => {
    const date = new Date(activeWeekStart());
    date.setDate(date.getDate() + index);
    return dateKey(date);
  };
  function wireDrag() {
    $$(".item").forEach((item) => {
      item.draggable = true;
      item.ondragstart = (e) => {
        dragged = { kind: "calendar", item };
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData(
          "text/plain",
          $("strong", item)?.textContent || "item",
        );
      };
    });
    $$(".task-line").forEach((row) => {
      row.draggable = true;
      row.ondragstart = (e) => {
        dragged = { kind: "task", item: row };
        e.dataTransfer.effectAllowed = "copy";
        e.dataTransfer.setData(
          "text/plain",
          $("strong", row)?.textContent || "task",
        );
      };
    });
    $$(".week-grid .day").forEach((day, index) => {
      day.ondragover = (e) => {
        e.preventDefault();
        day.classList.add("drop-target");
      };
      day.ondragleave = () => day.classList.remove("drop-target");
      day.ondrop = (e) => {
        e.preventDefault();
        day.classList.remove("drop-target");
        if (!dragged) return;
        if (dragged.kind === "calendar") {
          const item = dragged.item;
          const conflict = $$(".item.confirmed", day).some(
            (other) =>
              other !== item &&
              item.dataset.start &&
              other.dataset.start &&
              item.dataset.start < other.dataset.end &&
              item.dataset.end > other.dataset.start,
          );
          if (item.classList.contains("confirmed") && conflict) {
            flash("Move blocked: a confirmed event already occupies that time");
            dragged = null;
            return;
          }
          if (
            item.classList.contains("confirmed") &&
            !confirm("Move this confirmed event to another day?")
          ) {
            dragged = null;
            return;
          }
          day.appendChild(item);
          item.dataset.date = weekDateForIndex(index);
          if (item.classList.contains("confirmed"))
            $$(".item.pencil", day).forEach((p) => {
              if (
                item.dataset.start &&
                p.dataset.start &&
                item.dataset.start < p.dataset.end &&
                item.dataset.end > p.dataset.start
              )
                p.classList.add("conflict-bumped");
            });
        } else {
          const row = dragged.item;
          const item = document.createElement("div");
          item.className = "item task";
          item.style.cssText = "top:70%;height:6%";
          item.dataset.date = weekDateForIndex(index);
          item.innerHTML = `<strong>□ ${esc($("strong", row)?.textContent || "Task")}</strong><small>${esc($("small", row)?.textContent || "scheduled task")}</small>`;
          day.appendChild(item);
          item.onclick = () => api.openEditor("Task", item);
        }
        dragged = null;
        api.persist();
        wireDrag();
      };
      day.ondblclick = (e) => {
        if (e.target.closest(".item")) return;
        api.openEditor("Event");
        const f = api.form.elements;
        f.date.value = weekDateForIndex(index);
        const rect = day.getBoundingClientRect();
        const pct = (e.clientY - rect.top) / rect.height;
        const minutes = Math.round((7 * 60 + pct * 12 * 60) / 15) * 15;
        f.start.value = `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
        const end = minutes + 60;
        f.end.value = `${String(Math.floor(end / 60)).padStart(2, "0")}:${String(end % 60).padStart(2, "0")}`;
      };
    });
  }
  syncWeekShell();
  wireDrag();

  // Global search across the local planner.
  const searchPanel = document.createElement("div");
  searchPanel.className = "search-panel";
  searchPanel.innerHTML =
    '<section class="search-dialog glass"><button class="search-close">×</button><label>Search everything<input autofocus placeholder="Events, tasks, notes, shopping…"></label><div class="search-results"></div></section>';
  document.body.appendChild(searchPanel);
  $(".search").onclick = () => {
    searchPanel.classList.add("show");
    $("input", searchPanel).focus();
    runSearch("");
  };
  $(".search-close", searchPanel).onclick = () =>
    searchPanel.classList.remove("show");
  searchPanel.onclick = (e) => {
    if (e.target === searchPanel) searchPanel.classList.remove("show");
  };
  function records() {
    return [
      ...refreshCalendarRecords().map((x) => ({
        type: "Calendar",
        title: x.title,
        meta: x.meta,
        target: null,
      })),
      ...$$(".task-line").map((x) => ({
        type: "Task",
        title: $("strong", x)?.textContent,
        meta: $("small", x)?.textContent,
        target: x,
      })),
      ...$$(".library-note").map((x) => ({
        type: "Note",
        title: $("h3", x)?.textContent,
        meta: $("p", x)?.textContent,
        target: x,
      })),
      ...$$(".routine-card").map((x) => ({
        type: "Routine",
        title: $("h3", x)?.textContent,
        meta: $("p", x)?.textContent,
        target: x,
      })),
    ];
  }
  function runSearch(q) {
    q = q.toLowerCase();
    const found = records().filter(
      (x) => !q || (x.title + " " + x.meta).toLowerCase().includes(q),
    );
    $(".search-results", searchPanel).innerHTML =
      found
        .slice(0, 30)
        .map(
          (x, i) =>
            `<button data-result="${i}"><span>${esc(x.type)}</span><strong>${esc(x.title)}</strong><small>${esc(x.meta)}</small></button>`,
        )
        .join("") || "<p>No matches found.</p>";
    $$("[data-result]", searchPanel).forEach(
      (b, i) =>
        (b.onclick = () => {
          const r = found[i];
          searchPanel.classList.remove("show");
          if (r.type === "Calendar") {
            week();
            const target = $$(".item", calendar).find(
              (x) => $("strong", x)?.textContent === r.title,
            );
            api.openEditor("Event", target);
          } else api.openEditor(r.type, r.target);
        }),
    );
  }
  $("input", searchPanel).oninput = (e) => runSearch(e.target.value);

  // Working filters for calendar, tasks, and note collections.
  const filterButton = document.createElement("button");
  filterButton.className = "search";
  filterButton.setAttribute("aria-label", "Filter calendar");
  filterButton.textContent = "⌁";
  $(".topbar").insertBefore(filterButton, $(".search"));
  const filterPanel = document.createElement("div");
  filterPanel.className = "filter-panel glass";
  filterPanel.innerHTML =
    '<strong>Show in calendar</strong><label><input type="checkbox" value="confirmed" checked> Confirmed events</label><label><input type="checkbox" value="pencil" checked> Penciled events</label><label><input type="checkbox" value="task" checked> Tasks</label><label><input type="checkbox" value="routine" checked> Routines</label><label><input type="checkbox" value="shopping" checked> Shopping</label><label><input type="checkbox" value="work" checked> Work shading</label>';
  document.body.appendChild(filterPanel);
  filterButton.onclick = (e) => {
    e.stopPropagation();
    const r = filterButton.getBoundingClientRect();
    filterPanel.style.top = `${r.bottom + 8}px`;
    filterPanel.style.left = `${Math.max(12, r.right - 190)}px`;
    filterPanel.classList.toggle("show");
  };
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".filter-panel") && e.target !== filterButton)
      filterPanel.classList.remove("show");
  });
  $$("input", filterPanel).forEach(
    (input) =>
      (input.onchange = () => {
        const value = input.value;
        if (value === "work")
          $$(".day.work").forEach((x) =>
            x.classList.toggle("hide-work", !input.checked),
          );
        else
          $$("." + value).forEach((x) =>
            x.classList.toggle("filtered-out", !input.checked),
          );
        api.persist();
      }),
  );
  $$("#page-tasks .tabs button").forEach((tab, index) =>
    tab.addEventListener("click", () => {
      $$(".task-line").forEach((row, i) => {
        const done =
          row.classList.contains("done") ||
          $(".round-check", row)?.classList.contains("is-done");
        row.style.display =
          index === 4
            ? done
              ? "flex"
              : "none"
            : index === 0
              ? i < 3 && !done
                ? "flex"
                : "none"
              : index === 1
                ? !done
                  ? "flex"
                  : "none"
                : index === 2
                  ? i >= 3 && !done
                    ? "flex"
                    : "none"
                  : index === 3
                    ? row.textContent.toLowerCase().includes("someday")
                      ? "flex"
                      : "none"
                    : "flex";
      });
      $$("#page-tasks .attention").forEach(
        (x) => (x.style.display = index === 2 ? "flex" : "none"),
      );
    }),
  );
  $$("#page-notes .folders button").forEach((folder, index) =>
    folder.addEventListener("click", () => {
      $$(".library-note").forEach((note) => {
        const text = note.textContent.toLowerCase();
        note.style.display =
          index === 0 ||
          (index === 1 && text.includes("pinned")) ||
          (index === 2 && text.includes("margin")) ||
          (index === 3 && text.includes("shopping"))
            ? "block"
            : "none";
      });
    }),
  );

  // Settings is a real control center: each category has its own working panel.
  const settingsMain = $(".settings-main"),
    settingsNav = $$(".settings-nav button");
  // These controls are generated at startup. Remove any older saved copies
  // before rebuilding them so a restored planner snapshot cannot duplicate
  // account or install cards on every visit.
  $$(
    '[data-setting="calendar"],[data-setting="notifications"],[data-setting="accessibility"],.archive-block,.backup-block,.settings-profile-card,.install-app-block',
    settingsMain,
  ).forEach((x) => x.remove());
  const themeCatalog = [
    ["clean", "Clean", "Liquid glass"],
    ["linen", "Linen & Ink", "Tactile editorial"],
    ["botanical", "Botanical", "Organic garden"],
    ["coastal", "Coastal", "Sea glass & sand"],
    ["cafe", "Warm Café", "Cream & espresso"],
    ["paper", "Minimal Paper", "Quiet monochrome"],
    ["study", "Cozy Study", "Library warmth"],
    ["vintage", "Vintage Stationery", "Postmarks & type"],
  ];
  const themeBlock = $(".settings-main .setting-block");
  themeBlock.dataset.setting = "appearance";
  $(".theme-row", themeBlock).innerHTML = themeCatalog
    .map(
      ([id, name, description]) =>
        `<button class="theme-swatch theme-${id}" data-theme-choice="${id}"><i></i><strong>${name}</strong><small>${description}</small></button>`,
    )
    .join("");
  const themeTag = $(".setting-title .tag", themeBlock);
  const glassControl = document.createElement("label");
  glassControl.className = "glass-opacity-control";
  glassControl.innerHTML =
    '<span><strong>Frosted glass transparency</strong><small>Let more or less of the theme artwork show through.</small></span><span class="range-control"><input type="range" min="5" max="96" value="68" aria-label="Frosted glass transparency"><output>68%</output></span>';
  themeBlock.appendChild(glassControl);
  const glassRange = $("input", glassControl),
    glassOutput = $("output", glassControl);
  const applyGlassOpacity = (value) => {
    prefs.glassOpacity = +value;
    glassOutput.textContent = `${value}%`;
    document.documentElement.style.setProperty(
      "--glass-opacity",
      Math.max(0.05, Math.min(0.96, value / 100)),
    );
    savePrefs();
  };
  glassRange.value = prefs.glassOpacity ?? 68;
  glassOutput.textContent = `${glassRange.value}%`;
  glassRange.addEventListener("input", (event) =>
    applyGlassOpacity(event.target.value),
  );
  const themeArt = document.createElement("div");
  themeArt.className = "theme-art";
  themeArt.setAttribute("aria-hidden", "true");
  themeArt.innerHTML = "<span></span>";
  document.body.appendChild(themeArt);
  function selectTheme(id, announce = true) {
    if (!themeCatalog.some((x) => x[0] === id)) id = "clean";
    document.body.dataset.theme = id;
    prepareNavigationArt(id);
    prepareAccountArt(id);
    $$(".theme-swatch").forEach((b) =>
      b.classList.toggle("selected", b.dataset.themeChoice === id),
    );
    const info = themeCatalog.find((x) => x[0] === id);
    themeTag.textContent = info[1] + (id === "clean" ? " · default" : "");
    prefs.theme = id;
    savePrefs();
    api.persist();
    if (announce) flash(`${info[1]} theme applied`);
  }
  $$(".theme-swatch").forEach(
    (b) => (b.onclick = () => selectTheme(b.dataset.themeChoice)),
  );
  const settingBlocks = $$(".setting-block", settingsMain);
  settingBlocks[1].dataset.setting = "layout";
  settingBlocks[2].dataset.setting = "layout";
  settingBlocks[2].innerHTML =
    '<div class="setting-title"><div><h2>Display comfort</h2><p>Adjust information density without changing the theme.</p></div></div><label><span><strong>Density</strong><small>Scale calendar detail across every view</small></span><span class="range-control"><input class="density-setting" type="range" min="75" max="145" value="100"><output class="density-value">100%</output></span></label><label><span><strong>Roomier cards</strong><small>Add breathing room to lists and collections</small></span><button class="toggle" type="button" role="switch" data-pref="roomyCards"></button></label><label><span><strong>Expanded navigation</strong><small>Show page names when the planner opens</small></span><button class="toggle on" type="button" role="switch" data-pref="expandedNav"></button></label>';
  const calendarSettings = document.createElement("section");
  calendarSettings.className = "setting-block setting-lines";
  calendarSettings.dataset.setting = "calendar";
  calendarSettings.innerHTML =
    '<div class="setting-title"><div><h2>Calendar behavior</h2><p>Choose what the planning canvas shows by default.</p></div></div><label><span><strong>Planner margin</strong><small>Keep tasks and notes beside Week view</small></span><button class="toggle on" type="button" role="switch" data-pref="plannerMargin"></button></label><label><span><strong>Work shading</strong><small>Show your normal work hours faintly</small></span><button class="toggle on" type="button" role="switch" data-pref="workShading"></button></label><label><span><strong>Week starts Monday</strong><small>Use a Monday–Sunday planning rhythm</small></span><button class="toggle on" type="button" role="switch" data-pref="mondayStart"></button></label>';
  const notificationSettings = document.createElement("section");
  notificationSettings.className = "setting-block setting-lines";
  notificationSettings.dataset.setting = "notifications";
  notificationSettings.innerHTML =
    '<div class="setting-title"><div><h2>Gentle reminders</h2><p>In-app prompts stay quiet and can be dismissed.</p></div></div><label><span><strong>Morning overview</strong><small>A calm summary when you first open the planner</small></span><button class="toggle on" type="button" role="switch" data-pref="morningBrief"></button></label><label><span><strong>Routine prompts</strong><small>Ask before moving routines around exceptions</small></span><button class="toggle on" type="button" role="switch" data-pref="routinePrompts"></button></label><label><span><strong>Upcoming deadlines</strong><small>Surface due tasks in the planner margin</small></span><button class="toggle" type="button" role="switch" data-pref="deadlinePrompts"></button></label><div class="notification-preview"><strong>Device notifications</strong><p>When Calendar Guardian is installed, reminders use your phone or computer\'s system notification center under the app name.</p><div class="notification-actions"><button class="chip" type="button" data-device-notifications>Enable device notifications</button><button class="chip" type="button" data-test-notification hidden>Send a test</button></div><small data-notification-status>Not enabled on this device.</small></div>';
  const accessibilitySettings = document.createElement("section");
  accessibilitySettings.className = "setting-block setting-lines";
  accessibilitySettings.dataset.setting = "accessibility";
  accessibilitySettings.innerHTML =
    '<div class="setting-title"><div><h2>Accessibility</h2><p>Comfort controls apply throughout the app.</p></div></div><label><span><strong>Reduce motion</strong><small>Remove lifts, slides, and decorative movement</small></span><button class="toggle" type="button" role="switch" data-pref="reduceMotion"></button></label><label><span><strong>Higher contrast</strong><small>Strengthen borders, labels, and controls</small></span><button class="toggle" type="button" role="switch" data-pref="highContrast"></button></label><label><span><strong>Larger controls</strong><small>Increase interactive target sizes</small></span><button class="toggle" type="button" role="switch" data-pref="largeControls"></button></label>';
  settingsMain.append(
    calendarSettings,
    notificationSettings,
    accessibilitySettings,
  );
  const AUTH_SESSION_KEY = "clean-auth-session-v1",
    AUTH_USERS_KEY = "clean-auth-users-v1",
    MAX_CONNECTIONS = 20;
  // A cached name is not an account. Only demo mode may hydrate before the
  // secure adapter verifies Supabase; real profiles arrive via
  // guardian:cloud-session below.
  let currentUser;
  try {
    currentUser = JSON.parse(
      sessionStorage.getItem("clean-demo-user") || "null",
    );
  } catch {
    currentUser = null;
  }
  const connectionStorageKey = () =>
    currentUser ? `clean-calendar-connections-v3:${currentUser.id}` : null;
  const defaultConnections = [];
  let calendarConnections;
  try {
    calendarConnections = currentUser
      ? JSON.parse(
          (currentUser.demo ? sessionStorage : localStorage).getItem(
            connectionStorageKey(),
          ) || "[]",
        )
      : defaultConnections;
  } catch {
    calendarConnections = defaultConnections;
  }
  const accountButton = document.createElement("button");
  accountButton.className = "account-button";
  accountButton.type = "button";
  $(".side-bottom").prepend(accountButton);
  const mobileAccountButton = document.createElement("button");
  mobileAccountButton.className = "account-button mobile-account-button";
  mobileAccountButton.type = "button";
  mobileAccountButton.setAttribute("aria-label", "Open account");
  document.body.append(mobileAccountButton);
  // These imports give Vite ownership of the portrait files. CSS variables
  // then keep the same themed art visible in the sidebar, profile sheet, and
  // create-account choices instead of relying on stale relative URLs.
  const accountArtSources = {
    clean: [accountCleanFemale, accountCleanMale],
    linen: [accountLinenFemale, accountLinenMale],
    botanical: [accountBotanicalFemale, accountBotanicalMale],
    coastal: [accountCoastalFemale, accountCoastalMale],
    cafe: [accountCafeFemale, accountCafeMale],
    paper: [accountPaperFemale, accountPaperMale],
    study: [accountStudyFemale, accountStudyMale],
    vintage: [accountVintageFemale, accountVintageMale],
  };
  function prepareAccountArt(theme = document.body.dataset.theme || "clean") {
    const [female, male] = accountArtSources[theme] || accountArtSources.clean;
    document.documentElement.style.setProperty(
      "--account-art-female",
      `url("${female}")`,
    );
    document.documentElement.style.setProperty(
      "--account-art-male",
      `url("${male}")`,
    );
  }
  selectTheme(prefs.theme || document.body.dataset.theme || "clean", false);
  const avatarChoices =
    '<div class="avatar-choices"><label class="avatar-choice"><input type="radio" name="iconChoice" value="female" checked><span class="avatar-preview theme-female"></span><small>Female theme default</small></label><label class="avatar-choice"><input type="radio" name="iconChoice" value="male"><span class="avatar-preview theme-male"></span><small>Male theme default</small></label><label class="avatar-choice custom-choice"><input type="radio" name="iconChoice" value="custom"><span class="avatar-preview custom">＋</span><small>Local picture</small></label></div>';
  const authDialog = document.createElement("div");
  authDialog.className = "search-panel auth-dialog";
  authDialog.innerHTML =
    '<section class="search-dialog glass auth-card"><button class="auth-close search-close" type="button">×</button><div class="eyebrow">Your account</div><div class="auth-signed-out"><h2>Sign in</h2><p>Keep calendar connections attached to one profile across your devices.</p><div class="auth-tabs"><button type="button" class="active" data-auth-mode="signin">Sign in</button><button type="button" data-auth-mode="create">Create account</button></div><form class="auth-form"><div class="avatar-question" hidden><strong>First, choose your default icon</strong>' +
    avatarChoices +
    '<input class="signup-photo" type="file" accept="image/png,image/jpeg,image/webp"></div><label class="auth-name" hidden>Name<input name="name" autocomplete="name" placeholder="Your name"></label><label>Email<input name="email" type="email" autocomplete="email" required placeholder="you@example.com"></label><label>Password<input name="password" type="password" autocomplete="current-password" required minlength="6" placeholder="At least 6 characters"></label><label class="stay-signed-in"><input name="staySignedIn" type="checkbox" checked><span><strong>Stay signed in on this device</strong><small>Keep this selected only on a personal phone or computer.</small></span></label><div class="connection-security">Your account is stored on this PC. Passwords are saved as one-way hashes.</div><button class="primary-action" type="submit">Sign in</button></form><div class="auth-divider"><span>or</span></div><button class="demo-mode" type="button">Explore in demo mode</button></div><div class="auth-signed-in" hidden><span class="large-avatar"></span><div class="profile-icon-picker"><strong>Profile icon</strong>' +
    avatarChoices.replaceAll('name="iconChoice"', 'name="profileIconChoice"') +
    '<input class="profile-photo" type="file" accept="image/png,image/jpeg,image/webp" hidden></div><div class="avatar-crop-controls" hidden><strong>Photo framing</strong><label>Left / right<input type="range" name="avatarCropX" min="0" max="100" value="50"></label><label>Up / down<input type="range" name="avatarCropY" min="0" max="100" value="50"></label><label>Zoom<input type="range" name="avatarCropZoom" min="100" max="220" value="100"></label><small>Adjust how your photo sits inside its natural rounded frame. Saved everywhere you sign in.</small></div><h2></h2><p></p><button class="secure-profile primary-action" type="button" hidden>Secure this profile</button><button class="delete-legacy-profile auth-signout" type="button" hidden>Delete local profile</button><button class="auth-signout standard-signout" type="button">Sign out</button></div></section>';
  document.body.appendChild(authDialog);
  const googleAuthButton = document.createElement("button");
  googleAuthButton.className = "google-auth";
  googleAuthButton.type = "button";
  googleAuthButton.innerHTML =
    '<span aria-hidden="true">G</span>Continue with Google';
  $(".demo-mode", authDialog).before(googleAuthButton);
  const settingsProfileCard = document.createElement("button");
  settingsProfileCard.className = "settings-profile-card";
  settingsProfileCard.type = "button";
  settingsMain.prepend(settingsProfileCard);
  const authForm = $(".auth-form", authDialog);
  let authMode = "signin";
  function initials(user) {
    return (user?.name || user?.email || "?")
      .split(/[\s@._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((x) => x[0].toUpperCase())
      .join("");
  }
  const choiceImage = (user) =>
    user?.iconChoice === "custom" && user.avatar ? user.avatar : "";
  const cropStyle = (user) => {
    const crop = user?.avatarCrop || { x: 50, y: 50, zoom: 1 };
    return `style="object-position:${Number(crop.x) || 50}% ${Number(crop.y) || 50}%;transform:scale(${Math.max(1, Math.min(2.2, Number(crop.zoom) || 1))})"`;
  };
  function updateAccountUI() {
    const image = choiceImage(currentUser),
      themeGender = currentUser?.iconChoice === "male" ? "male" : "female",
      // A custom choice without a usable cloud photo must fall back to the
      // current theme portrait. Leaving it blank makes the signed-in account
      // control look broken while the photo URL is unavailable or expired.
      themeArt = !image,
      avatarMarkup = `<span class="account-avatar ${image ? "has-photo" : ""} ${themeArt ? "uses-theme-art " + themeGender : ""}">${image ? `<img src="${image}" ${cropStyle(currentUser)} alt="">` : currentUser && !themeArt ? esc(initials(currentUser)) : ""}</span>`,
      accountMarkup = `${avatarMarkup}<span class="label">${currentUser ? esc(currentUser.demo ? "Demo mode" : currentUser.name || currentUser.email) : "Sign in"}</span>`,
      floatingMarkup = `${avatarMarkup}<span class="label">${currentUser ? esc(currentUser.demo ? "Demo mode" : currentUser.name || currentUser.email) : "Sign in"}</span>`;
    [accountButton, mobileAccountButton].forEach((button) => {
      button.innerHTML = floatingMarkup;
      button.classList.toggle("signed-out", !currentUser);
      button.classList.toggle(
        "male-default",
        !currentUser || themeGender === "male",
      );
      button.title = currentUser
        ? currentUser.demo
          ? "Demo mode"
          : `Signed in as ${currentUser.email}`
        : "Sign in";
    });
    settingsProfileCard.innerHTML = `${accountMarkup}<span class="settings-profile-copy"><strong>${currentUser ? esc(currentUser.demo ? "Demo mode" : currentUser.name || "Your account") : "Your account"}</strong><small>${currentUser ? "Manage profile and sign-in" : "Sign in or create a secure account"}</small></span><span class="settings-profile-arrow">›</span>`;
    settingsProfileCard.classList.toggle("signed-out", !currentUser);
    const signedIn = $(".auth-signed-in", authDialog),
      signedOut = $(".auth-signed-out", authDialog);
    signedIn.hidden = !currentUser;
    signedOut.hidden = !!currentUser;
    if (currentUser) {
      const large = $(".large-avatar", signedIn);
      large.className = `large-avatar ${themeArt ? "uses-theme-art " + themeGender : ""}`;
      large.innerHTML = image
        ? `<img src="${image}" ${cropStyle(currentUser)} alt="Profile icon">`
        : themeArt
          ? ""
          : esc(initials(currentUser));
      $$('input[name="profileIconChoice"]', signedIn).forEach(
        (input) =>
          (input.checked =
            input.value ===
            (currentUser.iconChoice === "male"
              ? "male"
              : currentUser.iconChoice === "custom"
                ? "custom"
                : "female")),
      );
      $(".profile-icon-picker", signedIn).hidden = !!currentUser.demo;
      const cropControls = $(".avatar-crop-controls", signedIn),
        crop = currentUser.avatarCrop || { x: 50, y: 50, zoom: 1 };
      if (cropControls) {
        cropControls.hidden = !image || !!currentUser.demo;
        $(".avatarCropX", cropControls)?.value;
        const x = $('[name="avatarCropX"]', cropControls),
          y = $('[name="avatarCropY"]', cropControls),
          zoom = $('[name="avatarCropZoom"]', cropControls);
        if (x) x.value = String(crop.x ?? 50);
        if (y) y.value = String(crop.y ?? 50);
        if (zoom) zoom.value = String(Math.round((crop.zoom ?? 1) * 100));
      }
      $("h2", signedIn).textContent = currentUser.demo
        ? "Demo mode"
        : currentUser.name || "Your account";
      $("p", signedIn).textContent = currentUser.demo
        ? "Changes are temporary and reset when you exit."
        : currentUser.email;
      $(".auth-signout:not(.delete-legacy-profile)", signedIn).textContent =
        currentUser.demo ? "Exit demo" : "Sign out";
      $(".secure-profile", signedIn).hidden =
        !!currentUser.demo || !!currentUser.cloud;
      $(".delete-legacy-profile", signedIn).hidden =
        !!currentUser.demo || !!currentUser.cloud;
    }
  }
  function openAuth() {
    updateAccountUI();
    authDialog.classList.add("show");
  }
  accountButton.onclick = openAuth;
  mobileAccountButton.onclick = openAuth;
  settingsProfileCard.onclick = openAuth;
  $(".auth-close", authDialog).onclick = () =>
    authDialog.classList.remove("show");
  authDialog.onclick = (e) => {
    if (e.target === authDialog) authDialog.classList.remove("show");
  };
  $$("[data-auth-mode]", authDialog).forEach(
    (button) =>
      (button.onclick = () => {
        authMode = button.dataset.authMode;
        $$("[data-auth-mode]", authDialog).forEach((x) =>
          x.classList.toggle("active", x === button),
        );
        $("h2", $(".auth-signed-out", authDialog)).textContent =
          authMode === "create" ? "Create account" : "Sign in";
        $(".avatar-question", authDialog).hidden = authMode !== "create";
        $(".auth-name", authDialog).hidden = authMode !== "create";
        authForm.elements.name.required = authMode === "create";
        authForm.elements.password.autocomplete =
          authMode === "create" ? "new-password" : "current-password";
        $('button[type="submit"]', authForm).textContent =
          authMode === "create" ? "Create account" : "Sign in";
      }),
  );
  $(".secure-profile", authDialog).onclick = () => {
    if (!currentUser) return;
    authMode = "create";
    const prior = currentUser;
    $(".auth-signed-in", authDialog).hidden = true;
    $(".auth-signed-out", authDialog).hidden = false;
    $$("[data-auth-mode]", authDialog).forEach((x) =>
      x.classList.toggle("active", x.dataset.authMode === "create"),
    );
    $("h2", $(".auth-signed-out", authDialog)).textContent =
      "Secure this profile";
    $(".avatar-question", authDialog).hidden = false;
    $(".auth-name", authDialog).hidden = false;
    authForm.elements.name.required = true;
    authForm.elements.name.value = prior.name || "";
    authForm.elements.email.value = prior.email || "";
    authForm.elements.password.value = "";
    authForm.elements.password.autocomplete = "new-password";
    $('button[type="submit"]', authForm).textContent = "Secure account";
  };
  let pendingSignupAvatar = "";
  authForm.onsubmit = async (e) => {
    e.preventDefault();
    const cloud = window.guardianCloud,
      email = authForm.elements.email.value.trim().toLowerCase(),
      password = authForm.elements.password.value,
      name = authForm.elements.name.value.trim(),
      iconChoice = authForm.elements.iconChoice?.value || "female";
    if (!cloud?.configured) {
      flash(
        "Secure accounts are not configured yet. No local account was created.",
      );
      return;
    }
    if (
      authMode === "create" &&
      iconChoice === "custom" &&
      !pendingSignupAvatar
    ) {
      flash("Choose a local picture or select another icon");
      return;
    }
    try {
      cloud.setStaySignedIn(!!authForm.elements.staySignedIn?.checked);
      const result =
        authMode === "create"
          ? await cloud.signUp({ email, password, name, iconChoice })
          : await cloud.signIn({ email, password });
      if (!result.session) {
        flash("Check your email to confirm this secure account, then sign in.");
        return;
      }
      const user = result.user;
      currentUser = {
        id: user.id,
        name: user.user_metadata?.display_name || name || email.split("@")[0],
        email: user.email,
        iconChoice: user.user_metadata?.icon_choice || iconChoice,
        cloud: true,
      };
      localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(currentUser));
      localStorage.removeItem(AUTH_USERS_KEY);
      authDialog.classList.remove("show");
      flash(`Secure account ready for ${currentUser.name}`);
      location.reload();
    } catch (error) {
      flash(error?.message || "Unable to create your secure account.");
    }
  };
  $(".demo-mode", authDialog).onclick = () => {
    sessionStorage.setItem("clean-demo-mode", "true");
    sessionStorage.setItem(
      "clean-demo-user",
      JSON.stringify({
        id: "demo",
        name: "Demo",
        email: "demo@local",
        demo: true,
      }),
    );
    sessionStorage.removeItem("clean-planner-demo-v1");
    location.reload();
  };
  $(".standard-signout", authDialog).onclick = () => {
    if (currentUser?.demo) {
      sessionStorage.removeItem("clean-demo-mode");
      sessionStorage.removeItem("clean-demo-user");
      sessionStorage.removeItem("clean-planner-demo-v1");
      sessionStorage.removeItem(connectionStorageKey());
      location.reload();
      return;
    }
    localStorage.removeItem(AUTH_SESSION_KEY);
    currentUser = null;
    calendarConnections = [];
    updateAccountUI();
    renderConnections();
    authDialog.classList.remove("show");
    flash("Signed out");
  };
  $(".delete-legacy-profile", authDialog).onclick = () => {
    if (!currentUser || currentUser.cloud || currentUser.demo) return;
    if (
      !confirm(
        "Delete this local profile and all local Calendar Guardian data from this device?",
      )
    )
      return;
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (
        key &&
        (key.startsWith("clean-") || key.startsWith("calendar-guardian-"))
      )
        localStorage.removeItem(key);
    }
    sessionStorage.removeItem("clean-demo-mode");
    sessionStorage.removeItem("clean-demo-user");
    sessionStorage.removeItem("clean-planner-demo-v1");
    location.reload();
  };
  async function saveIconChoice(iconChoice, avatar = "") {
    if (!currentUser || currentUser.demo) return;
    currentUser.iconChoice = iconChoice;
    currentUser.avatar = iconChoice === "custom" ? avatar : "";
    if (currentUser.cloud)
      await window.guardianCloud.saveProfileIconChoice(iconChoice);
    localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(currentUser));
    updateAccountUI();
  }
  const readLocalPicture = (file, done) => {
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      flash("Choose an image under 2 MB");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => done(reader.result);
    reader.readAsDataURL(file);
  };
  $(".custom-choice", authForm).onclick = () =>
    $(".signup-photo", authForm).click();
  $(".signup-photo", authForm).onchange = (e) =>
    readLocalPicture(e.target.files[0], (data) => {
      pendingSignupAvatar = data;
      $(".custom-choice .avatar-preview", authForm).style.backgroundImage =
        `url("${data}")`;
      $(".custom-choice input", authForm).checked = true;
    });
  $$('input[name="profileIconChoice"]', authDialog).forEach(
    (input) =>
      (input.onchange = async () => {
        if (input.value === "custom") {
          $(".profile-photo", authDialog).click();
          return;
        }
        try {
          await saveIconChoice(input.value);
          flash("Profile icon updated");
        } catch (error) {
          flash(error?.message || "Unable to update profile icon");
        }
      }),
  );
  $(".profile-photo", authDialog).onchange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const crop = { x: 50, y: 50, zoom: 1 };
      if (currentUser?.cloud) {
        const saved = await window.guardianCloud.saveProfileAvatar(file, crop);
        currentUser = {
          ...currentUser,
          iconChoice: "custom",
          avatar: saved.avatar,
          avatarCrop: saved.avatarCrop,
        };
      } else
        readLocalPicture(file, (data) => {
          currentUser.avatar = data;
          currentUser.iconChoice = "custom";
        });
      updateAccountUI();
      flash("Profile picture updated");
    } catch (error) {
      flash(error?.message || "Unable to save profile picture");
    }
  };
  $$('input[name^="avatarCrop"]', authDialog).forEach(
    (input) =>
      (input.oninput = () => {
        if (!currentUser?.avatar) return;
        currentUser.avatarCrop = {
          x: +$('.avatar-crop-controls [name="avatarCropX"]', authDialog).value,
          y: +$('.avatar-crop-controls [name="avatarCropY"]', authDialog).value,
          zoom:
            +$('.avatar-crop-controls [name="avatarCropZoom"]', authDialog)
              .value / 100,
        };
        updateAccountUI();
        clearTimeout(window.__avatarCropSave);
        window.__avatarCropSave = setTimeout(
          () =>
            window.guardianCloud
              ?.saveAvatarCrop(currentUser.avatarCrop)
              .catch((error) =>
                flash(error?.message || "Unable to save photo framing"),
              ),
          350,
        );
      }),
  );
  updateAccountUI();
  const integrations = document.createElement("section");
  integrations.className = "setting-block calendar-connections";
  integrations.dataset.setting = "calendar";
  calendarSettings.before(integrations);
  const providerMark = {
    Google: "G",
    Microsoft: "M",
    iCloud: "◌",
    CalDAV: "↻",
    ICS: "↓",
  };
  const normalizeCloudConnection = (connection) => ({
    id: connection.id,
    provider: connection.provider === "google" ? "Google" : connection.provider,
    account: connection.label,
    label: connection.label,
    mode: connection.mode || "two-way",
    status:
      connection.status === "connected"
        ? "Connected securely"
        : connection.status || "Pending",
    calendars: Array.isArray(connection.settings?.calendars)
      ? connection.settings.calendars
      : [],
    cloud: true,
  });
  const saveConnections = () => {
    if (currentUser?.cloud) return;
    const key = connectionStorageKey();
    if (key)
      (currentUser?.demo ? sessionStorage : localStorage).setItem(
        key,
        JSON.stringify(calendarConnections),
      );
  };
  function renderConnections() {
    const visibleCalendars = calendarConnections
      .flatMap((x) => x.calendars)
      .filter((x) => x.visible).length;
    integrations.innerHTML = `<div class="setting-title connection-title"><div><h2>External calendar accounts</h2><p>Optional: bring calendars from another service into Calendar Guardian.</p></div><div class="connection-actions"><span class="connection-count"><strong>${calendarConnections.length}</strong> of ${MAX_CONNECTIONS} added · ${visibleCalendars} visible</span><button class="primary-action add-connection" type="button">+ Add external account</button></div></div><div class="connection-list">${calendarConnections.map((connection, index) => `<article class="connection-card" data-connection="${esc(connection.id)}"><header><span class="provider-mark provider-${connection.provider.toLowerCase()}">${providerMark[connection.provider] || "•"}</span><span class="connection-identity"><strong>${esc(connection.label)}</strong><small>${esc(connection.provider)} · ${esc(connection.account)}</small></span><span class="sync-state">✓ ${esc(connection.status)}</span><button class="chip sync-account" type="button">Sync now</button><button class="mini-btn expand-connection" type="button" aria-label="Show calendars" aria-expanded="true">⌃</button></header><div class="connection-calendars">${connection.calendars.map((cal, calIndex) => `<div class="connected-calendar"><input class="calendar-color" type="color" value="${cal.color}" aria-label="Calendar color"><span><strong>${esc(cal.name)}</strong><small>${connection.mode}${cal.primary ? " · default for new events" : ""}</small></span><label class="compact-control">Visible <button class="toggle ${cal.visible ? "on" : ""}" type="button" data-calendar-action="visible" data-index="${index}" data-calendar-index="${calIndex}" role="switch" aria-checked="${cal.visible}"></button></label><label class="compact-control">Conflicts <button class="toggle ${cal.conflicts ? "on" : ""}" type="button" data-calendar-action="conflicts" data-index="${index}" data-calendar-index="${calIndex}" role="switch" aria-checked="${cal.conflicts}"></button></label><button class="chip make-default" type="button" data-index="${index}" data-calendar-index="${calIndex}" ${cal.primary ? "disabled" : ""}>${cal.primary ? "Default" : "Make default"}</button></div>`).join("")}<footer><span>${esc(connection.mode)} synchronization · automatically checks every 15 minutes</span><button class="disconnect-account" type="button" data-index="${index}">Disconnect account</button></footer></div></article>`).join("")}</div>`;
    if (!currentUser)
      $(".connection-list", integrations).innerHTML =
        '<div class="connection-empty signed-out-calendar"><div class="eyebrow">Account required</div><h3>Sign in to add an external calendar</h3><p>This is optional. It is separate from installing Calendar Guardian on your phone.</p><button class="primary-action sign-in-calendar" type="button">Sign in or create account</button></div>';
    else if (!calendarConnections.length)
      $(".connection-list", integrations).innerHTML =
        '<div class="connection-empty"><div class="eyebrow">No external accounts</div><h3>Add an external calendar account</h3><p>Optional. Google Calendar is available first; other services show their real availability below.</p><div class="provider-grid"><button type="button" data-connect-provider="Google"><span class="provider-mark provider-google">G</span><strong>Google</strong><small>Available now · Google Calendar</small></button><button type="button" disabled title="Microsoft sign-in is not connected yet"><span class="provider-mark provider-microsoft">M</span><strong>Microsoft</strong><small>Coming next · Outlook / Microsoft 365</small></button><button type="button" disabled title="iCloud authorization is not connected yet"><span class="provider-mark provider-icloud">◌</span><strong>iCloud</strong><small>Planned · Apple Calendar</small></button><button type="button" disabled title="CalDAV is not connected yet"><span class="provider-mark">↻</span><strong>CalDAV</strong><small>Planned · Fastmail, Nextcloud, and more</small></button><button type="button" disabled title="ICS subscriptions are not connected yet"><span class="provider-mark">↓</span><strong>Calendar link</strong><small>Planned · read-only ICS subscription</small></button></div></div>';
    // The two directions deliberately remain explicit.  "From" never writes
    // to Google; "To" only sends Guardian edits still waiting to be pushed.
    $$(".sync-account", integrations).forEach((button) => {
      button.textContent = "Sync from Google";
      button.classList.add("sync-from-account");
      const outbound = document.createElement("button");
      outbound.type = "button";
      outbound.className = "chip sync-to-account";
      outbound.textContent = "Sync to Google";
      button.after(outbound);
    });
    $(".sign-in-calendar", integrations)?.addEventListener("click", openAuth);
    $(".add-connection", integrations)?.addEventListener("click", () => {
      if (!currentUser) {
        openAuth();
        return;
      }
      if (calendarConnections.length >= MAX_CONNECTIONS) {
        flash("20-account limit reached");
        return;
      }
      openConnectionDialog("Google");
    });
    $$("[data-connect-provider]", integrations).forEach(
      (button) =>
        (button.onclick = () =>
          openConnectionDialog(button.dataset.connectProvider)),
    );
    $$(".expand-connection", integrations).forEach(
      (button) =>
        (button.onclick = () => {
          const details = $(
              ".connection-calendars",
              button.closest(".connection-card"),
            ),
            expanded = !details.hidden;
          details.hidden = expanded;
          button.textContent = expanded ? "⌄" : "⌃";
          button.setAttribute("aria-expanded", String(!expanded));
        }),
    );
    $$(".sync-account", integrations).forEach(
      (button, index) =>
        (button.onclick = async () => {
          const connection = calendarConnections[index];
          if (connection.cloud) {
            button.disabled = true;
            button.textContent = "Syncing…";
            try {
              const result = await window.guardianCloud.syncCalendarConnection(
                connection.id,
              );
              await refreshCloudPlannerItems();
              const refreshed =
                await window.guardianCloud.listCalendarConnections();
              calendarConnections = refreshed.map(normalizeCloudConnection);
              renderConnections();
              flash(
                `${result.imported || 0} imported · ${result.updated || 0} updated`,
              );
            } catch (error) {
              button.disabled = false;
              button.textContent = "Sync now";
              flash(error?.message || "Google Calendar sync could not finish");
            }
            return;
          }
          connection.status = "Synced just now";
          saveConnections();
          renderConnections();
          flash("Calendar account synced");
        }),
    );
    $$(".sync-from-account", integrations).forEach(
      (button, index) =>
        (button.onclick = async () => {
          const connection = calendarConnections[index];
          if (!connection.cloud) return;
          button.disabled = true;
          button.textContent = "Reading…";
          try {
            const result = await window.guardianCloud.syncCalendarConnection(
              connection.id,
            );
            await refreshCloudPlannerItems();
            const refreshed =
              await window.guardianCloud.listCalendarConnections();
            calendarConnections = refreshed.map(normalizeCloudConnection);
            renderConnections();
            flash(
              `${result.imported || 0} imported · ${result.updated || 0} updated from Google`,
            );
          } catch (error) {
            button.disabled = false;
            button.textContent = "Sync from Google";
            flash(error?.message || "Google Calendar sync could not finish");
          }
        }),
    );
    $$(".sync-to-account", integrations).forEach(
      (button) =>
        (button.onclick = async () => {
          button.disabled = true;
          button.textContent = "Sending…";
          try {
            const result = await window.guardianCloud.syncPlannerToGoogle();
            renderConnections();
            flash(
              `${result.pushed || 0} Guardian change${result.pushed === 1 ? "" : "s"} sent to Google`,
            );
          } catch (error) {
            button.disabled = false;
            button.textContent = "Sync to Google";
            flash(
              error?.message || "Guardian changes could not be sent to Google",
            );
          }
        }),
    );
    $$("[data-calendar-action]", integrations).forEach(
      (button) =>
        (button.onclick = async () => {
          const connection = calendarConnections[+button.dataset.index],
            cal = connection.calendars[+button.dataset.calendarIndex],
            key = button.dataset.calendarAction,
            previous = cal[key];
          cal[key] = !previous;
          try {
            if (connection.cloud)
              await window.guardianCloud.updateCalendarConnectionSettings(
                connection.id,
                { calendars: connection.calendars },
              );
            else saveConnections();
            renderConnections();
            if (key === "visible") await refreshCloudPlannerItems();
            flash(`${cal.name} ${key} ${cal[key] ? "on" : "off"}`);
          } catch (error) {
            cal[key] = previous;
            renderConnections();
            flash(error?.message || "Unable to save calendar choice");
          }
        }),
    );
    $$(".calendar-color", integrations).forEach(
      (input, index) =>
        (input.oninput = () => {
          const all = calendarConnections.flatMap(
              (connection) => connection.calendars,
            ),
            cal = all[index];
          cal.color = input.value;
          saveConnections();
        }),
    );
    $$(".make-default", integrations).forEach(
      (button) =>
        (button.onclick = () => {
          const connection = calendarConnections[+button.dataset.index];
          calendarConnections.forEach((x) =>
            x.calendars.forEach((cal) => (cal.primary = false)),
          );
          connection.calendars[+button.dataset.calendarIndex].primary = true;
          saveConnections();
          renderConnections();
          flash("Default calendar updated");
        }),
    );
    $$(".disconnect-account", integrations).forEach(
      (button) =>
        (button.onclick = async () => {
          const index = +button.dataset.index,
            connection = calendarConnections[index];
          if (
            !confirm(
              `Disconnect ${connection.label}? Events remain in the original calendar.`,
            )
          )
            return;
          try {
            if (connection.cloud)
              await window.guardianCloud.disconnectCalendarConnection(
                connection.id,
              );
            calendarConnections.splice(index, 1);
            saveConnections();
            renderConnections();
            flash("Calendar account disconnected");
          } catch (error) {
            flash(error?.message || "Unable to disconnect the account.");
          }
        }),
    );
  }
  const connectionDialog = document.createElement("div");
  connectionDialog.className = "search-panel connection-dialog";
  connectionDialog.innerHTML =
    '<section class="search-dialog glass"><button class="connection-close search-close" type="button">×</button><div class="eyebrow">Calendar connection</div><h2>Connect Google Calendar</h2><p class="dialog-copy">Choose your Google account in Google’s secure sign-in window. Calendar Guardian never sees your Google password.</p><form class="connection-form"><input name="provider" value="Google" type="hidden"><label class="connection-label" hidden>Connection name <small>(optional)</small><input name="label" placeholder="Work calendar"></label><label class="connection-account" hidden>Account or calendar address<input name="account" placeholder="Provided by your calendar provider"></label><label hidden>Synchronization<select name="mode"><option>Two-way</option><option>Read-only</option></select></label><div class="provider-help connection-security">Next: choose your Google account, review Google’s permission screen, and approve access. You can disconnect it any time in Settings.</div><button class="primary-action" type="submit">Continue with Google</button></form></section>';
  document.body.appendChild(connectionDialog);
  const connectionForm = $(".connection-form", connectionDialog),
    providerHelp = $(".provider-help", connectionDialog),
    connectionSubmit = $(".primary-action", connectionDialog),
    connectionLabel = $(".connection-label", connectionDialog),
    connectionAccount = $(".connection-account", connectionDialog);
  const providerInstructions = {
    Google:
      "Continue with Google to choose the account securely. Calendar Guardian never asks for your Google password.",
    Microsoft:
      "Microsoft calendar sign-in is the next provider to be connected.",
    iCloud:
      "Connect an iCloud calendar account using Apple’s supported authorization flow.",
    CalDAV:
      "Enter the CalDAV server address supplied by your calendar provider.",
    ICS: "Paste a public or private ICS subscription address. ICS connections are read-only.",
  };
  function updateProviderForm() {
    const provider = connectionForm.elements.provider.value,
      isOAuth = ["Google", "Microsoft"].includes(provider);
    providerHelp.textContent = providerInstructions[provider];
    connectionLabel.hidden = isOAuth;
    connectionAccount.hidden = isOAuth;
    connectionSubmit.textContent =
      provider === "Google"
        ? "Continue with Google"
        : provider === "Microsoft"
          ? "Continue with Microsoft"
          : "Continue";
    connectionForm.elements.mode.value =
      provider === "ICS" ? "Read-only" : "Two-way";
    connectionForm.elements.mode.disabled = provider === "ICS";
    connectionForm.elements.account.placeholder =
      provider === "CalDAV"
        ? "https://calendar.example.com"
        : provider === "ICS"
          ? "https://example.com/calendar.ics"
          : "Provided by your calendar provider";
  }
  function openConnectionDialog(provider = "Google") {
    connectionForm.reset();
    connectionForm.elements.provider.value = provider;
    updateProviderForm();
    connectionDialog.classList.add("show");
  }
  connectionForm.elements.provider.onchange = updateProviderForm;
  $(".connection-close", connectionDialog).onclick = () =>
    connectionDialog.classList.remove("show");
  connectionDialog.onclick = (e) => {
    if (e.target === connectionDialog)
      connectionDialog.classList.remove("show");
  };
  // OAuth providers are never allowed to create a pretend local connection.
  // Invoke the secure launcher directly so this remains reliable even if an
  // auxiliary adapter has not finished initializing yet.
  connectionForm.onsubmit = async (e) => {
    e.preventDefault();
    const provider = connectionForm.elements.provider.value;
    if (!["Google", "Microsoft"].includes(provider)) {
      flash("This connection type is not available yet.");
      return;
    }
    const cloud = window.guardianCloud;
    try {
      if (!cloud?.configured)
        throw new Error(
          "Secure calendar sign-in is not configured yet. No calendar was added.",
        );
      const session = await cloud.session();
      if (!session?.user) {
        providerHelp.textContent =
          "Sign in to your secure Calendar Guardian account before connecting Google. Your current local-only session cannot safely store a calendar connection.";
        flash("Sign in to your secure account before connecting Google");
        openAuth();
        return;
      }
      await cloud.beginCalendarConnection(provider.toLowerCase());
    } catch (error) {
      const message =
        error?.message ||
        "Unable to begin secure calendar sign-in. No calendar was added.";
      providerHelp.textContent = message;
      flash(message);
    }
  };
  settingsNav[2].textContent = "External calendars";
  renderConnections();
  // The feature layer is intentionally decoupled from cloud auth. Receive the
  // verified session and connections only from the cloud adapter, never from
  // a name that happened to remain in local storage.
  const savedState = $("#page-settings .saved-state");
  const updateSavedState = (message) => {
    if (savedState) savedState.textContent = message;
  };
  window.addEventListener("guardian:cloud-session", (event) => {
    currentUser = { ...event.detail, cloud: true };
    calendarConnections = [];
    clearCloudWorkPlaceholders();
    updateAccountUI();
    updateSavedState("✓ Saved to your account");
    renderConnections();
  });
  window.addEventListener("guardian:preferences-saved", (event) => {
    if (!currentUser?.cloud) return;
    updateSavedState(
      event.detail?.cloud
        ? "✓ Saved to your account"
        : "Could not save to your account",
    );
  });
  window.addEventListener("guardian:cloud-connections", (event) => {
    if (!currentUser?.cloud) return;
    calendarConnections = (event.detail || []).map(normalizeCloudConnection);
    renderConnections();
  });
  // Imported calendars are cloud data, not decorative connection cards.  Put
  // the current week's records on the actual planner canvas as soon as the
  // authenticated adapter supplies them.
  // Cloud rows are rebuilt after every refresh. Seed the editor directly
  // from their persisted values rather than depending on any earlier DOM
  // wrapper, so editing a task cannot silently reset its time.
  const openCloudTaskEditor = (row) => {
    if (!row) return;
    api.openEditor("Task", row);
    const form = api.form.elements;
    if (row.dataset.date) form.date.value = row.dataset.date;
    if (row.dataset.start) form.start.value = row.dataset.start;
    if (row.dataset.end) form.end.value = row.dataset.end;
    if (row.dataset.recurrence) form.recurrence.value = row.dataset.recurrence;
    form.notes.value = row.dataset.notes || "";
  };
  // Routines and work exceptions use the same persisted scheduling fields as
  // tasks. Populate the shared editor from the cloud row before the form can
  // be saved, so editing never silently changes a saved date, time, or repeat
  // rule back to the defaults.
  const openCloudScheduledEditor = (type, row) => {
    if (!row) return;
    api.openEditor(type, row);
    const form = api.form.elements;
    if (row.dataset.title) form.title.value = row.dataset.title;
    if (row.dataset.date) form.date.value = row.dataset.date;
    if (row.dataset.start) form.start.value = row.dataset.start;
    if (row.dataset.end) form.end.value = row.dataset.end;
    if (row.dataset.recurrence) form.recurrence.value = row.dataset.recurrence;
    form.notes.value = row.dataset.notes || "";
  };
  function renderCloudCollections(records) {
    // These pages are projections of the same account records as the
    // calendar—not a second set of sample cards kept in browser storage.
    const taskHost = $("#page-tasks .content-card"),
      routineHost = $(".routine-grid"),
      noteHost = $(".notes-grid"),
      workHost = $("#page-work .content-card");
    const own = records.filter(
      (record) => record?.details?.provider === "guardian",
    );
    const routineRecords = own.filter((record) => record.kind === "routine"),
      noteRecords = own.filter((record) => record.kind === "note");
    const updateRoutineSummary = () => {
      const values = $$("#page-routines .summary-strip strong");
      if (values.length < 4) return;
      const today = dateKey(new Date());
      const completed = routineRecords.filter(
        (record) => record.details?.routine_completed_on === today,
      );
      const paused = routineRecords.filter(
        (record) => record.status === "paused",
      );
      const active = routineRecords.length - paused.length;
      values[0].textContent = String(active);
      values[1].textContent = String(completed.length);
      values[2].textContent = active
        ? `${Math.round((completed.length / active) * 100)}%`
        : "—";
      values[3].textContent = String(paused.length);
    };
    updateRoutineSummary();
    const noteCounts = $$("#page-notes .folders button span");
    if (noteCounts.length >= 4) {
      noteCounts[0].textContent = String(noteRecords.length);
      noteCounts[1].textContent = String(
        noteRecords.filter((record) => record.details?.pinned).length,
      );
      noteCounts[2].textContent = String(
        noteRecords.filter((record) => record.details?.planner_margin).length,
      );
      noteCounts[3].textContent = String(
        noteRecords.filter((record) => record.kind === "shopping").length,
      );
    }
    const margin = $(".margin");
    if (margin) {
      $$(
        ".focus,.section-title,.check-row,.note-card,.margin-cloud-row",
        margin,
      ).forEach((node) => node.remove());
      const focus = document.createElement("div");
      focus.className = "focus";
      focus.innerHTML =
        '<div class="eyebrow">Your planner margin</div><p>Tasks and notes stay connected to your account.</p><small>Use the pencil to edit an item.</small>';
      margin.append(focus);
      const taskItems = own.filter((record) => record.kind === "task"),
        noteItems = own.filter((record) => record.kind === "note");
      if (taskItems.length) {
        const title = document.createElement("div");
        title.className = "section-title";
        title.textContent = "Tasks";
        margin.append(title);
        taskItems.slice(0, 6).forEach((record) => {
          const row = document.createElement("button");
          row.type = "button";
          row.className = "margin-cloud-row";
          row.innerHTML = `<span>□</span><span><strong>${esc(record.title)}</strong><small>${esc(record.details?.notes || "Scheduled task")}</small></span><i>✎</i>`;
          row.onclick = () =>
            api.openEditor(
              "Task",
              $$(".task-line").find(
                (item) => item.dataset.cloudId === record.id,
              ),
            );
          margin.append(row);
        });
      }
      if (noteItems.length) {
        const title = document.createElement("div");
        title.className = "section-title";
        title.textContent = "Notes";
        margin.append(title);
        noteItems.slice(0, 4).forEach((record) => {
          const row = document.createElement("button");
          row.type = "button";
          row.className = "margin-cloud-row";
          row.innerHTML = `<span>≋</span><span><strong>${esc(record.title)}</strong><small>${esc(record.details?.notes || "Note")}</small></span><i>✎</i>`;
          row.onclick = () =>
            api.openEditor(
              "Note",
              $$(".library-note").find(
                (item) => item.dataset.cloudId === record.id,
              ),
            );
          margin.append(row);
        });
      }
    }
    if (taskHost) {
      $$(".task-line,.attention,.empty-state", taskHost).forEach((node) =>
        node.remove(),
      );
      own
        .filter((record) => record.kind === "task")
        .forEach((record) => {
          const row = document.createElement("div");
          row.className = "task-line";
          row.dataset.cloudId = record.id;
          const date = new Date(record.starts_at),
            end = new Date(record.ends_at || date.getTime() + 3600000),
            done = record.status === "completed";
          row.dataset.date = dateKey(date);
          row.dataset.start = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
          row.dataset.end = `${String(end.getHours()).padStart(2, "0")}:${String(end.getMinutes()).padStart(2, "0")}`;
          row.dataset.recurrence = record.recurrence?.frequency || "none";
          row.dataset.notes = record.details?.notes || "";
          row.classList.toggle("done", done);
          row.innerHTML = `<button class="round-check ${done ? "is-done" : ""}" aria-label="${done ? "Mark task open" : "Complete task"}"></button><div><strong>${esc(record.title)}</strong><small>${esc(record.timing_precision === "exact" ? date.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "Anytime")} · ${esc(record.details?.notes || "scheduled task")}</small></div><span class="tag sage">${done ? "completed" : "scheduled"}</span><button class="ghost">Schedule</button>`;
          row.onclick = (click) => {
            if (!click.target.closest("button")) openCloudTaskEditor(row);
          };
          $(".ghost", row).onclick = () => openCloudTaskEditor(row);
          $(".round-check", row).onclick = async (click) => {
            click.stopPropagation();
            const check = click.currentTarget,
              next = !check.classList.contains("is-done");
            check.disabled = true;
            try {
              await window.guardianCloud.saveItem({
                ...record,
                status: next ? "completed" : "confirmed",
              });
              await refreshCloudPlannerItems();
              flash(next ? "Task completed" : "Task reopened");
            } catch (error) {
              flash(error?.message || "Could not update task");
            } finally {
              check.disabled = false;
            }
          };
          taskHost.insertBefore(row, $(".section-bar", taskHost) || null);
        });
      if (!taskHost.querySelector(".task-line")) {
        const empty = document.createElement("p");
        empty.className = "empty-state";
        empty.textContent =
          "No tasks yet. Add your first task when you are ready.";
        taskHost.append(empty);
      }
    }
    if (routineHost) {
      $$(".routine-card,.empty-state", routineHost).forEach((node) =>
        node.remove(),
      );
      routineRecords.forEach((record) => {
        const card = document.createElement("article");
        card.className = "routine-card";
        card.dataset.cloudId = record.id;
        card.dataset.title = record.title;
        const start = new Date(record.starts_at);
        const end = new Date(record.ends_at || start.getTime() + 3600000);
        card.dataset.date = dateKey(start);
        card.dataset.start = `${String(start.getHours()).padStart(2, "0")}:${String(start.getMinutes()).padStart(2, "0")}`;
        card.dataset.end = `${String(end.getHours()).padStart(2, "0")}:${String(end.getMinutes()).padStart(2, "0")}`;
        card.dataset.recurrence = record.recurrence?.frequency || "none";
        card.dataset.notes = record.details?.notes || "";
        const completedToday =
          record.details?.routine_completed_on === dateKey(new Date());
        card.innerHTML = `<div class="routine-symbol">○</div><span class="tag sage">${esc(record.recurrence?.frequency || "weekly")}</span><h3>${esc(record.title)}</h3><p>${esc(record.details?.notes || "Flexible")}</p><div class="week-dots"><i>M</i><i>T</i><i>W</i><i>T</i><i>F</i><i>S</i><i>S</i></div><button class="wide-ghost">${completedToday ? "Reopen routine" : "Mark complete"}</button>`;
        card.onclick = (click) => {
          if (!click.target.closest("button"))
            openCloudScheduledEditor("Routine", card);
        };
        $(".wide-ghost", card).onclick = async (click) => {
          click.stopPropagation();
          const button = click.currentTarget,
            today = dateKey(new Date()),
            completed = record.details?.routine_completed_on === today;
          button.disabled = true;
          try {
            await window.guardianCloud.saveItem({
              ...record,
              details: {
                ...record.details,
                routine_completed_on: completed ? null : today,
              },
            });
            await refreshCloudPlannerItems();
            flash(completed ? "Routine reopened" : "Routine completed");
          } catch (error) {
            flash(error?.message || "Could not update routine");
          } finally {
            button.disabled = false;
          }
        };
        routineHost.append(card);
      });
      if (!routineHost.querySelector(".routine-card")) {
        const empty = document.createElement("p");
        empty.className = "empty-state";
        empty.textContent =
          "No routines yet. Add one when you want a little structure.";
        routineHost.append(empty);
      }
    }
    if (noteHost) {
      $$(".library-note,.empty-state", noteHost).forEach((node) =>
        node.remove(),
      );
      noteRecords.forEach((record) => {
        const note = document.createElement("article");
        note.className = "library-note";
        note.dataset.cloudId = record.id;
        note.innerHTML = `<small>NOTE</small><h3>${esc(record.title)}</h3><p>${esc(record.details?.notes || "")}</p><footer>Saved to your account</footer>`;
        note.onclick = () => openNote(note);
        noteHost.append(note);
      });
      if (!noteHost.querySelector(".library-note")) {
        const empty = document.createElement("p");
        empty.className = "empty-state";
        empty.textContent =
          "No notes yet. Keep the things you want close here.";
        noteHost.append(empty);
      }
    }
    if (workHost) {
      $$(".exception", workHost).forEach((node) => node.remove());
      own
        .filter((record) => record.kind === "work")
        .forEach((record) => {
          const date = new Date(record.starts_at),
            end = record.ends_at ? new Date(record.ends_at) : date,
            row = document.createElement("div");
          row.className = "exception";
          row.dataset.cloudId = record.id;
          row.dataset.title = record.title;
          row.dataset.date = dateKey(date);
          row.dataset.start = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
          row.dataset.end = `${String(end.getHours()).padStart(2, "0")}:${String(end.getMinutes()).padStart(2, "0")}`;
          row.dataset.recurrence = record.recurrence?.frequency || "none";
          row.dataset.notes = record.details?.notes || "";
          row.innerHTML = `<span class="date-box"><b>${date.getDate()}</b>${date.toLocaleString("en", { month: "short" }).toUpperCase()}</span><div><strong>${esc(record.title)}</strong><small>${esc(date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }))}–${esc(end.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }))} · ${esc(record.details?.notes || "work exception")}</small></div><span class="tag blue">adjusted</span>`;
          row.onclick = (click) => {
            if (!click.target.closest("button"))
              openCloudScheduledEditor("Work", row);
          };
          workHost.append(row);
        });
    }
  }
  window.addEventListener("guardian:cloud-items", (event) => {
    if (!currentUser?.cloud || !$(".week-grid", calendar)) return;
    // Google events named "Work" / "Shift" are classified in the secure
    // sync function.  Reflect that detected pattern in Work as an editable
    // normal week rather than making the person manually recreate it.
    const cloudRecords = event.detail || [];
    renderCloudCollections(cloudRecords);
    const isImportedWorkPattern = (record) =>
      record?.kind === "work" ||
      record?.details?.detected_work ||
      (record?.details?.provider === "google" &&
        /^(?:work(?:[\s:–—-]+(?:shift|schedule|hours?|office))?|(?:morning|afternoon|evening|night)[\s-]+shift|shift(?:[\s:–—-]+(?:work|office))?|office(?:[\s-]+hours?)?|on[\s-]?duty)$/i.test(
          String(record.title || "").trim(),
        ));
    const detectedWork = cloudRecords.filter(isImportedWorkPattern);
    const workDays = $$("#page-work .shift-week>div");
    detectedWork.forEach((record) => {
      const startAt = new Date(record.starts_at),
        endAt = record.ends_at ? new Date(record.ends_at) : null;
      const weekday = (startAt.getDay() + 6) % 7,
        slot = workDays[weekday];
      if (!slot || !endAt) return;
      slot.classList.remove("off");
      const format = (time) =>
        time
          .toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
          .replace(":00", "");
      // Empty cloud accounts intentionally remove the starter schedule markup.
      // Rebuild the small labels here when a real imported work pattern exists.
      let startLabel = $("[data-work-start]", slot),
        endLabel = $("[data-work-end]", slot);
      if (!startLabel || !endLabel) {
        const inherited = $$("span", slot);
        if (inherited.length >= 2) {
          startLabel = inherited[0];
          endLabel = inherited[1];
        } else {
          startLabel = document.createElement("span");
          startLabel.dataset.workStart = "true";
          const bar = document.createElement("em");
          endLabel = document.createElement("span");
          endLabel.dataset.workEnd = "true";
          slot.append(startLabel, bar, endLabel);
        }
      }
      startLabel.textContent = format(startAt);
      endLabel.textContent = format(endAt);
      const small = $("small", slot);
      if (small) small.remove();
      slot.dataset.detectedWork = "true";
      // The same real shift must be shown in the calendar's shaded day, not
      // the starter 8:30–4:30 placeholder left by the prototype shell.
      const calendarOffset = dayDistance(record.starts_at);
      const calendarDay = $$(".week-grid .day", calendar)[calendarOffset];
      if (calendarDay && calendarOffset >= 0 && calendarOffset < 7) {
        calendarDay.classList.add("work");
        calendarDay.style.setProperty(
          "--work-label",
          JSON.stringify(`work · ${format(startAt)}–${format(endAt)}`),
        );
      }
    });
    const workHeading = $("#page-work .card-head h2");
    if (workHeading && detectedWork.length) {
      workHeading.textContent = "Detected work week";
      workHeading.title =
        "Derived from eligible Google Calendar events. You can still edit this schedule.";
    }
    // Connected calendar hours are the source of truth when Work is detected.
    // A saved Work schedule remains the fallback for accounts without one.
    if (
      !detectedWork.length &&
      Array.isArray(prefs.workSchedule) &&
      prefs.workSchedule.length
    )
      applyWorkSchedule(prefs.workSchedule);
    const dateFor = (value) => {
      const d = new Date(value);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };
    const enabled = new Set(
      calendarConnections.flatMap((connection) =>
        connection.calendars
          .filter((calendar) => calendar.visible)
          .map((calendar) => `${connection.id}:${calendar.id}`),
      ),
    );
    const eligible = (event.detail || []).filter((record) => {
      if (!record?.starts_at || !record.title) return false;
      return !(
        record.details?.connection_id &&
        record.details?.calendar_id &&
        !enabled.has(
          `${record.details.connection_id}:${record.details.calendar_id}`,
        )
      );
    });
    // Google expands repeating events into individual occurrences. Keep the
    // earliest occurrence as the series anchor and let the calendar renderer
    // project it into the current week/month. This prevents a repeating plan
    // from behaving like dozens of unrelated one-off records.
    const seriesAnchors = new Map(),
      normalizedEligible = [];
    eligible.forEach((record) => {
      const seriesId = record.recurrence?.provider_series_id;
      if (record.details?.provider !== "google" || !seriesId) {
        normalizedEligible.push(record);
        return;
      }
      const key = `${record.details?.connection_id || ""}:${record.details?.calendar_id || ""}:${seriesId}`,
        existing = seriesAnchors.get(key);
      if (!existing || Date.parse(record.starts_at) < Date.parse(existing.starts_at))
        seriesAnchors.set(key, record);
    });
    normalizedEligible.push(...seriesAnchors.values());
    cloudPlannerRecords = normalizedEligible.map((record) => {
      const begins = new Date(record.starts_at),
        ends = record.ends_at
          ? new Date(record.ends_at)
          : new Date(begins.getTime() + 3600000);
      const minutes = begins.getHours() * 60 + begins.getMinutes();
      const recurrence =
        record.recurrence?.frequency ||
        record.details?.recurrence?.frequency ||
        "";
      const repeatLabel = recurrence ? ` · ↻ ${recurrence}` : "";
      const time = begins.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        }),
        location =
          record.details?.location ||
          record.details?.calendar_name ||
          "Calendar";
      // Existing synced rows from older releases may still be tagged as a
      // routine.  Treat only the narrow Google work-pattern titles as Work
      // while the background sync upgrades those rows in the cloud.
      const isImportedWorkPattern =
        record.details?.provider === "google" &&
        /^(?:work(?:[\s:–—-]+(?:shift|schedule|hours?|office))?|(?:morning|afternoon|evening|night)[\s-]+shift|shift(?:[\s:–—-]+(?:work|office))?|office(?:[\s-]+hours?)?|on[\s-]?duty)$/i.test(
          String(record.title || "").trim(),
        );
      const kind =
        // A detected Google work pattern is its own first-class planner type.
        // It belongs in Work (and drives the work shading), never in Routines.
        record.kind === "work" ||
        record.details?.detected_work ||
        isImportedWorkPattern
          ? "work"
          : record.kind === "task"
            ? "task"
            : record.kind === "routine"
              ? "routine"
              : record.kind === "shopping"
                ? "shopping"
                : "confirmed";
      return {
        title: record.title,
        meta: `${time} · ${location}${repeatLabel}`,
        kind,
        date: dateKey(dateFor(record.starts_at)),
        recurrence: recurrence || "none",
        top: Math.max(1, Math.min(92, ((minutes - 420) / 720) * 100)),
        cloudId: record.id,
        record,
      };
    });
    // The renderer below projects this shared cloud list into whichever week
    // is currently open. Do not snapshot it into weekMarkup: that is what
    // previously made navigation look like the account only had one week.
    if (currentView === "week") renderCloudWeek();
    calendarRecords = refreshCalendarRecords(currentView === "month");
    if (currentView === "agenda") agenda();
    else if (currentView === "month") month();
    else if (currentView === "day") day();
  });
  async function refreshCloudPlannerItems() {
    if (!currentUser?.cloud || !window.guardianCloud?.listItems) return;
    // Every view reads one shared planning horizon, rather than a single
    // seeded week. The client paginates it safely in cloud-client.js.
    const now = new Date(),
      start = new Date(now.getFullYear() - 1, 0, 1),
      end = new Date(now.getFullYear() + 2, 0, 1);
    const records = await window.guardianCloud.listItems(
      start.toISOString(),
      end.toISOString(),
    );
    window.dispatchEvent(
      new CustomEvent("guardian:cloud-items", { detail: records }),
    );
  }
  // Low-cost automatic calendar refresh while the installed app or browser
  // is open. A server scheduler can extend this to closed devices later, but
  // this keeps every connected calendar current without requiring a manual
  // button press during normal use.
  let automaticCalendarSyncInFlight = false;
  let lastAutomaticCalendarSyncAt = 0;
  async function automaticallySyncConnectedCalendars({ force = false } = {}) {
    if (
      automaticCalendarSyncInFlight ||
      !currentUser?.cloud ||
      document.visibilityState === "hidden"
    )
      return;
    const interval = 15 * 60 * 1000;
    if (!force && Date.now() - lastAutomaticCalendarSyncAt < interval) return;
    const connections = calendarConnections.filter(
      (connection) => connection.cloud && connection.status !== "error",
    );
    if (!connections.length) return;
    automaticCalendarSyncInFlight = true;
    try {
      await Promise.all(
        connections.map((connection) =>
          window.guardianCloud.syncCalendarConnection(connection.id),
        ),
      );
      // Guardian edits remain authoritative and are explicitly pushed back
      // after importing provider changes, preventing refreshes from undoing
      // a just-created Guardian item.
      await window.guardianCloud.syncPlannerToGoogle();
      await refreshCloudPlannerItems();
      lastAutomaticCalendarSyncAt = Date.now();
    } catch (error) {
      console.warn("Automatic calendar sync deferred", error);
    } finally {
      automaticCalendarSyncInFlight = false;
    }
  }
  window.addEventListener("guardian:cloud-connections", () =>
    automaticallySyncConnectedCalendars({ force: true }),
  );
  window.addEventListener("focus", () => automaticallySyncConnectedCalendars());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible")
      automaticallySyncConnectedCalendars();
  });
  window.setInterval(
    () => automaticallySyncConnectedCalendars(),
    15 * 60 * 1000,
  );
  // Calendar Guardian owns changes made here. Save the real event first, then
  // send that one change to the selected two-way Google calendar.
  async function saveGuardianCalendarEdit(target, form, type) {
    if (
      !currentUser?.cloud ||
      !window.guardianCloud?.saveItem ||
      !["Event", "Shopping"].includes(type)
    )
      return;
    const value = (name) =>
      typeof form[name] === "string" ? form[name] : form[name]?.value;
    const date = value("date") || target?.dataset.date;
    if (!date) return;
    const endDate = value("endDate") || target?.dataset.endDate || date;
    if (endDate < date) throw new Error("End date must be on or after the start date.");
    const allDay = value("timing") === "All day",
      start = value("start") || target?.dataset.start || "09:00",
      end = value("end") || target?.dataset.end || "10:00";
    const title = (value("title") || "").trim();
    const color = (form.customColor || form.color?.dataset?.custom === "true") ? validEventColor(value("color")) : "";
    if (!title) return;
    const existingId = target?.dataset.cloudId || undefined,
      details = {
        provider: target?.dataset.cloudItem ? "google" : "guardian",
        guardian_dirty: true,
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago",
        location: "",
        notes: value("notes") || "",
        ...(color ? { color } : {}),
      };
    const saved = await window.guardianCloud.saveItem({
      ...(existingId ? { id: existingId } : {}),
      kind: type === "Shopping" ? "shopping" : "event",
      title,
      starts_at: new Date(`${date}T${allDay ? "00:00:00" : `${start}:00`}`).toISOString(),
      ends_at: new Date(`${endDate}T${allDay ? "23:59:59.999" : `${end}:00`}`).toISOString(),
      timing_precision: allDay ? "date-only" : value("timing") === "Exact time" ? "exact" : "sometime",
      status: value("status") || "confirmed",
      details,
    });
    if (target) target.dataset.cloudId = saved.id;
    await window.guardianCloud.pushPlannerItem(saved.id);
    await refreshCloudPlannerItems();
  }
  // A delete must be visible immediately. The editor target can be a proxy
  // created by Month/Day/Agenda, so removing that one DOM node is not enough;
  // remove the account record from the shared renderer and redraw the current
  // view before waiting on the provider round trip.
  function removePlannerItemImmediately(id) {
    if (!id) return;
    cloudPlannerRecords = cloudPlannerRecords.filter(
      (entry) => entry.record?.id !== id && entry.cloudId !== id,
    );
    calendarRecords = calendarRecords.filter((entry) => entry.cloudId !== id);
    $$(`[data-cloud-id="${id}"]`).forEach((node) => node.remove());
    $$(`[data-cloud-id="${id}"]`, document).forEach((node) => node.remove());
    if (currentView === "week") renderCloudWeek();
    else if (currentView === "month") month();
    else if (currentView === "day") day();
    else if (currentView === "agenda") agenda();
  }
  api.form.addEventListener("submit", (event) => {
    const target = api.editing,
      type = api.currentType,
      form = api.form.elements;
    const values = {
      date: form.date.value,
      start: form.start.value,
      end: form.end.value,
      title: form.title.value,
      timing: form.timing.value,
      status: form.status.value,
      notes: form.notes.value,
      color: form.color.value,
      customColor: form.color.dataset.custom === "true",
    };
    queueMicrotask(() =>
      saveGuardianCalendarEdit(target, values, type).catch((error) =>
        flash(
          error?.message ||
            "Calendar change saved in Guardian but could not be sent to Google",
        ),
      ),
    );
  });
  // The original editor removed a card locally and fired the cloud deletion
  // separately. On a real connection those two races made the first tap look
  // successful even when Google had not finished deleting it. Capture the tap
  // and make deletion one awaited transaction instead.
  $(".delete-action", api.editor)?.addEventListener(
    "click",
    async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = event.currentTarget,
        target = api.editing,
        id = target?.dataset.cloudId;
      if (!target) return;
      button.disabled = true;
      button.textContent = "Deleting…";
      try {
        if (id && currentUser?.cloud) {
          removePlannerItemImmediately(id);
          api.closeEditor();
          await window.guardianCloud.pushPlannerItem(id, true);
        } else {
          window.CleanArchive?.add(target);
          target.remove();
          api.closeEditor();
        }
        api.persist();
        flash("Event deleted");
      } catch (error) {
        // The optimistic removal is only temporary if the secure deletion
        // fails. Restore the server truth so the person never loses a record
        // just because the network or provider rejected the request.
        await refreshCloudPlannerItems().catch(() => {});
        flash(
          error?.message || "Could not delete this event. Nothing was removed.",
        );
      } finally {
        button.disabled = false;
        button.textContent = "Delete";
      }
    },
    true,
  );
  // Cloud auth can finish before this feature layer has registered the two
  // events above (especially after an OAuth redirect). Reconcile once here so
  // a real, server-saved connection always appears without a second reload.
  (async () => {
    try {
      const session = await window.guardianCloud?.verifiedSession?.();
      if (!session?.user) return;
      const profile = (await window.guardianCloud.loadProfile?.()) || {};
      currentUser = {
        id: session.user.id,
        email: session.user.email,
        name:
          profile.name ||
          session.user.user_metadata?.display_name ||
          session.user.email?.split("@")[0] ||
          "Guardian user",
        iconChoice:
          profile.iconChoice ||
          session.user.user_metadata?.icon_choice ||
          "female",
        avatar: profile.avatar || "",
        avatarCrop: profile.avatarCrop,
        cloud: true,
      };
      updateAccountUI();
      updateSavedState("✓ Saved to your account");
      const connections = await window.guardianCloud.listCalendarConnections();
      calendarConnections = (connections || []).map(normalizeCloudConnection);
      renderConnections();
      // cloud-adapter can finish authentication before this enhancement has
      // subscribed to its first item event. Fetch once after this layer owns
      // the verified user so the planner is never left with a blank shell.
      await refreshCloudPlannerItems();
    } catch (error) {
      console.warn("Unable to refresh cloud calendar connections", error);
    }
  })();
  if (sessionStorage.getItem("clean-demo-mode") === "true") {
    const deadlineCallout = document.createElement("div");
    deadlineCallout.className = "deadline-callout";
    deadlineCallout.innerHTML =
      "<span>Due soon</span><strong>Refill prescription · Friday</strong>";
    const marginFocus = $(".margin .focus");
    marginFocus?.after(deadlineCallout);
  }
  function applySettingPrefs() {
    document.documentElement.style.setProperty(
      "--glass-opacity",
      Math.max(0.05, Math.min(0.96, (prefs.glassOpacity ?? 68) / 100)),
    );
    document.body.classList.toggle(
      "hide-planner-margin",
      prefs.plannerMargin === false,
    );
    document.body.classList.toggle(
      "hide-work-shading",
      prefs.workShading === false,
    );
    document.body.classList.toggle(
      "week-starts-sunday",
      prefs.mondayStart === false,
    );
    document.body.classList.toggle(
      "hide-morning-brief",
      prefs.morningBrief === false,
    );
    document.body.classList.toggle("show-deadlines", !!prefs.deadlinePrompts);
    document.body.classList.toggle(
      "routine-prompts-off",
      prefs.routinePrompts === false,
    );
    document.body.classList.toggle("roomy-cards", !!prefs.roomyCards);
    document.body.classList.toggle("reduce-motion", !!prefs.reduceMotion);
    document.body.classList.toggle("high-contrast", !!prefs.highContrast);
    document.body.classList.toggle("large-controls", !!prefs.largeControls);
    $("#app").classList.toggle("open", innerWidth > 800 && !!prefs.expandedNav);
    localStorage.setItem("clean-nav-expanded", String(!!prefs.expandedNav));
    $$("[data-pref]", settingsMain).forEach((toggle) => {
      toggle.classList.toggle("on", !!prefs[toggle.dataset.pref]);
      toggle.setAttribute("aria-checked", String(!!prefs[toggle.dataset.pref]));
    });
    const promptNote = $$("#page-work .exception small").find((x) =>
      x.textContent.includes("routines"),
    );
    if (promptNote)
      promptNote.textContent = prefs.routinePrompts
        ? "PTO · routines will ask what to do"
        : "PTO · routines stay unchanged";
  }
  $$("[data-pref]", settingsMain).forEach((toggle) => {
    const key = toggle.dataset.pref;
    toggle.onclick = () => {
      prefs[key] = !prefs[key];
      savePrefs();
      applySettingPrefs();
      flash(
        `${toggle.closest("label").querySelector("strong").textContent} ${prefs[key] ? "on" : "off"}`,
      );
    };
  });
  applySettingPrefs();
  const deviceNotificationButton = $(
    "[data-device-notifications]",
    notificationSettings,
  );
  const testNotificationButton = $(
    "[data-test-notification]",
    notificationSettings,
  );
  const notificationStatus = $(
    "[data-notification-status]",
    notificationSettings,
  );
  const refreshDeviceNotificationUI = () => {
    const supported = "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
    const granted = supported && Notification.permission === "granted";
    if (!supported) {
      deviceNotificationButton.disabled = true;
      deviceNotificationButton.textContent = "Device notifications unavailable";
      notificationStatus.textContent = "This browser does not support installed-app notifications.";
      testNotificationButton.hidden = true;
      return;
    }
    deviceNotificationButton.textContent = granted
      ? "Device notifications enabled"
      : "Enable device notifications";
    deviceNotificationButton.disabled = granted;
    testNotificationButton.hidden = !granted;
    notificationStatus.textContent = granted
      ? "Enabled for this device. Reminders arrive through the system notification center even when Calendar Guardian is closed."
      : Notification.permission === "denied"
        ? "Notifications are blocked for this site in this browser's settings."
        : "Not enabled on this device.";
  };
  deviceNotificationButton.onclick = async () => {
    if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") throw new Error("Device notifications were not enabled");
      const { publicKey } = await window.guardianCloud.notificationConfig();
      const registration = await navigator.serviceWorker.ready;
      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        const key = Uint8Array.from(atob(publicKey.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - publicKey.length % 4) % 4)), (c) => c.charCodeAt(0));
        subscription = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
      }
      await window.guardianCloud.subscribeToNotifications(subscription.toJSON());
      prefs.deviceNotifications = true;
      savePrefs();
      refreshDeviceNotificationUI();
      flash("Device notifications enabled");
    } catch (error) {
      prefs.deviceNotifications = false;
      savePrefs();
      refreshDeviceNotificationUI();
      flash(error?.message || "Device notifications were not enabled");
    }
  };
  testNotificationButton.onclick = async () => {
    try {
      const result = await window.guardianCloud.sendNotificationTest();
      flash(result.sent ? "Test notification sent" : "No active device notification subscription");
    } catch (error) {
      flash(error?.message || "Could not send a test notification");
    }
  };
  refreshDeviceNotificationUI();
  function showSetting(category) {
    settingsNav.forEach((b, i) =>
      b.classList.toggle(
        "active",
        [
          "appearance",
          "layout",
          "calendar",
          "notifications",
          "archive",
          "accessibility",
        ][i] === category,
      ),
    );
    $$("[data-setting]", settingsMain).forEach(
      (block) => (block.hidden = block.dataset.setting !== category),
    );
  }
  settingsNav.forEach(
    (b, i) =>
      (b.onclick = () =>
        showSetting(
          [
            "appearance",
            "layout",
            "calendar",
            "notifications",
            "archive",
            "accessibility",
          ][i],
        )),
  );

  // Local backup, restore, and reset controls.
  const savedArchiveHtml = $(".archive-block .archive-list")?.innerHTML || "";
  $$(".backup-block,.archive-block").forEach((x) => x.remove());
  const archive = document.createElement("section");
  archive.className = "setting-block archive-block";
  archive.dataset.setting = "archive";
  archive.innerHTML =
    '<div class="setting-title"><div><h2>Archive</h2><p>Removed items remain recoverable here.</p></div><span class="tag archive-count">0 items</span></div><div class="archive-list"><p class="archive-empty">Nothing archived.</p></div>';
  $(".settings-main").appendChild(archive);
  const archiveList = $(".archive-list", archive);
  if (savedArchiveHtml) archiveList.innerHTML = savedArchiveHtml;
  const updateArchiveCount = () => {
    const count = $$(".archive-row", archiveList).length;
    $(".archive-count", archive).textContent =
      `${count} item${count === 1 ? "" : "s"}`;
    $(".archive-empty", archive).style.display = count ? "none" : "block";
  };
  function wireArchiveRow(row) {
    $("[data-restore]", row).onclick = () => {
      const wrap = document.createElement("div");
      wrap.innerHTML = decodeURIComponent(row.dataset.html);
      const item = wrap.firstElementChild;
      const dest = $(row.dataset.destination);
      if (dest && item) {
        dest.prepend(item);
        row.remove();
        updateArchiveCount();
        api.persist();
        flash("Item restored");
      }
    };
    $("[data-forget]", row).onclick = () => {
      row.remove();
      updateArchiveCount();
      api.persist();
    };
  }
  $$(".archive-row", archiveList).forEach(wireArchiveRow);
  window.CleanArchive = {
    add(target) {
      const destination = target.classList.contains("task-line")
        ? "#page-tasks .content-card"
        : target.classList.contains("routine-card")
          ? ".routine-grid"
          : target.classList.contains("library-note")
            ? ".notes-grid"
            : target.classList.contains("exception")
              ? "#page-work .content-card"
              : ".week-grid .day";
      const title =
        target.querySelector("strong,h3")?.textContent || "Archived item";
      const row = document.createElement("div");
      row.className = "archive-row";
      row.dataset.html = encodeURIComponent(target.outerHTML);
      row.dataset.destination = destination;
      row.innerHTML = `<span><strong>${esc(title)}</strong><small>Archived just now</small></span><button data-restore>Restore</button><button data-forget>Delete permanently</button>`;
      archiveList.prepend(row);
      wireArchiveRow(row);
      updateArchiveCount();
      api.persist();
    },
  };
  updateArchiveCount();
  const backup = document.createElement("section");
  backup.className = "setting-block backup-block";
  backup.dataset.setting = "archive";
  backup.innerHTML =
    '<div class="setting-title"><div><h2>Calendar data</h2><p>Back up this device or deliberately start over.</p></div></div><div class="backup-actions"><a data-backup="export" download="calendar-guardian-backup.json">Export backup</a><label class="restore-button">Restore backup<input type="file" accept="application/json"></label><button data-backup="reset">Clear local view</button><button class="danger-action" data-calendar-clear type="button">Clear calendars</button></div><small class="backup-status">Clear calendars preserves connections but erases Guardian items and events in selected connected calendars.</small>';
  $(".settings-main").appendChild(backup);
  const installApp = document.createElement("section");
  installApp.className = "setting-block install-app-block";
  installApp.dataset.setting = "appearance";
  installApp.innerHTML =
    '<div class="setting-title"><div><h2>Install Calendar Guardian</h2><p>Use it like an app on your phone or computer, with its own icon and standalone window.</p></div></div><div class="install-app-actions"><button class="primary-action" type="button" hidden>Install on this device</button><p class="install-status">On a computer: open this site in Chrome or Edge, then use the <strong>Install</strong> icon in the address bar or the browser menu. On Android: choose <strong>Install app</strong> or <strong>Add to Home screen</strong>. On iPhone: Share → <strong>Add to Home Screen</strong>.</p></div>';
  settingsMain.insertBefore(installApp, themeBlock);
  let installPrompt;
  const installButton = $(".primary-action", installApp),
    installStatus = $(".install-status", installApp);
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    installPrompt = event;
    installButton.hidden = false;
    installStatus.textContent = "Install Calendar Guardian on this device.";
  });
  installButton.onclick = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const result = await installPrompt.userChoice;
    installPrompt = null;
    installButton.hidden = true;
    installStatus.textContent =
      result.outcome === "accepted"
        ? "Calendar Guardian is installing."
        : "Installation was not completed.";
  };
  window.addEventListener("appinstalled", () => {
    installPrompt = null;
    installButton.hidden = true;
    installStatus.textContent =
      "Calendar Guardian is installed on this device.";
  });
  // Older saved snapshots can be restored after feature modules run. Reclaim
  // these generated cards at the end of startup so stale markup never turns
  // into duplicate account or install panels.
  function repairGeneratedSettings() {
    if (!settingsMain.contains(settingsProfileCard))
      settingsMain.prepend(settingsProfileCard);
    settingsMain.querySelectorAll(".settings-profile-card").forEach((card) => {
      if (card !== settingsProfileCard) card.remove();
    });
    if (!settingsMain.contains(installApp)) {
      const anchor = settingsMain.querySelector(".setting-block");
      if (anchor) settingsMain.insertBefore(installApp, anchor);
      else settingsMain.append(installApp);
    }
    settingsMain.querySelectorAll(".install-app-block").forEach((card) => {
      if (card !== installApp) card.remove();
    });
  }
  repairGeneratedSettings();
  window.addEventListener("load", repairGeneratedSettings, { once: true });
  let repairingGeneratedSettings = false;
  new MutationObserver(() => {
    if (repairingGeneratedSettings) return;
    repairingGeneratedSettings = true;
    queueMicrotask(() => {
      repairGeneratedSettings();
      repairingGeneratedSettings = false;
    });
  }).observe(settingsMain, { childList: true });
  queueMicrotask(api.persist);
  $('[data-backup="export"]').onpointerdown = (e) => {
    api.persist();
    const payload = {
      format: "calendar-guardian-backup",
      version: 1,
      data: JSON.parse(localStorage.getItem("clean-planner-local-v3") || "{}"),
      preferences: JSON.parse(localStorage.getItem(PREFS_KEY) || "{}"),
    };
    e.currentTarget.href =
      "data:application/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(payload, null, 2));
  };
  $('[data-backup="export"]').onclick = () => flash("Backup exported");
  $(".restore-button input").onchange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const payload = JSON.parse(reader.result);
        if (
          !["calendar-guardian-backup", "clean-planner-backup"].includes(
            payload.format,
          )
        )
          throw new Error();
        localStorage.setItem(
          "clean-planner-local-v3",
          JSON.stringify(payload.data),
        );
        localStorage.setItem(
          PREFS_KEY,
          JSON.stringify(payload.preferences || {}),
        );
        location.reload();
      } catch {
        flash("That backup file is not valid");
      }
    };
    reader.readAsText(file);
  };
  $('[data-backup="reset"]').onclick = () => {
    if (
      confirm(
        "Clear this planner on this device? Your current local changes will be removed.",
      )
    ) {
      localStorage.removeItem("clean-planner-local-v3");
      localStorage.removeItem(PREFS_KEY);
      location.reload();
    }
  };
  $("[data-calendar-clear]").onclick = async () => {
    if (!currentUser?.cloud) {
      flash("Sign in to your secure account before clearing calendars.");
      return;
    }
    const warning =
      "Clear Calendar Guardian and the selected calendars in connected accounts? This permanently erases events, tasks, routines, notes, and shopping items. Connections will remain. This cannot be undone.";
    if (!confirm(warning)) return;
    const button = $("[data-calendar-clear]");
    button.disabled = true;
    button.textContent = "Clearing…";
    try {
      const result = await window.guardianCloud.clearCalendars();
      localStorage.removeItem("clean-planner-local-v3");
      flash(
        `Calendar cleared${result.remoteFailed ? ` · ${result.remoteFailed} external item${result.remoteFailed === 1 ? "" : "s"} could not be removed` : ""}`,
      );
      location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = "Clear calendars";
      flash(
        error?.message ||
          "Calendar clearing could not finish. Nothing else was removed.",
      );
    }
  };
  showSetting("appearance");
  const layoutChoices = $$(".layout-choice");
  layoutChoices.forEach((b) =>
    b.classList.toggle(
      "selected",
      (b.querySelector(".timegrid") ? "timegrid" : "columns") === prefs.layout,
    ),
  );
  layoutChoices.forEach((b) =>
    b.addEventListener("click", () => {
      prefs.layout = b.querySelector(".timegrid") ? "timegrid" : "columns";
      layoutChoices.forEach((x) => x.classList.toggle("selected", x === b));
      $(".planner").classList.toggle(
        "traditional",
        prefs.layout === "timegrid",
      );
      savePrefs();
      flash(`${$("strong", b).textContent} applied`);
    }),
  );
  const densityControl = $(".density-setting"),
    densityValue = $(".density-value");
  const applyDensity = (value) => {
    prefs.scale = value;
    densityValue && (densityValue.textContent = `${value}%`);
    document.documentElement.style.setProperty("--scale", value / 100);
    document.documentElement.style.setProperty("--ui-density", value / 100);
    const topScale = $("#scale");
    if (topScale) topScale.value = value;
    savePrefs();
  };
  if (densityControl) {
    densityControl.value = prefs.scale;
    densityValue.textContent = `${prefs.scale}%`;
    densityControl.addEventListener("input", (e) =>
      applyDensity(e.target.value),
    );
  }
  $("#scale")?.addEventListener("input", (e) => {
    if (densityControl) densityControl.value = e.target.value;
    applyDensity(e.target.value);
  });
  $$(".wide-ghost,.layout-choice").forEach((b) =>
    b.addEventListener("click", () => queueMicrotask(api.persist)),
  );

  // Normal work schedule editor.
  const scheduleEditor = document.createElement("div");
  scheduleEditor.className = "search-panel schedule-panel";
  scheduleEditor.innerHTML =
    '<section class="search-dialog glass"><button class="schedule-close search-close">×</button><h2>Normal work week</h2><form class="work-schedule-form"></form></section>';
  document.body.appendChild(scheduleEditor);
  const scheduleForm = $(".work-schedule-form", scheduleEditor);
  const weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  scheduleForm.innerHTML =
    weekDays
      .map(
        (d, i) =>
          `<div class="work-row"><strong>${d}</strong><label>Start<input name="start${i}" type="time" value="${i === 2 ? "09:00" : "08:30"}"></label><label>End<input name="end${i}" type="time" value="${i === 2 ? "17:00" : i === 4 ? "15:00" : "16:30"}"></label></div>`,
      )
      .join("") +
    '<button class="primary-action" type="submit">Save schedule</button>';
  const formatClock = (value) => {
    const [hour = 0, minute = 0] = String(value || "")
      .split(":")
      .map(Number);
    if (!Number.isFinite(hour) || !Number.isFinite(minute)) return value || "";
    const suffix = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${String(minute).padStart(2, "0")} ${suffix}`;
  };
  const applyWorkSchedule = (schedule) => {
    if (!Array.isArray(schedule)) return;
    schedule.forEach((shift, index) => {
      const workCell = $$(".shift-week>div")[index],
        calendarDay = $$(".week-grid .day")[index];
      if (workCell) {
        workCell.classList.remove("off");
        const spans = $$("span", workCell);
        if (spans.length >= 2) {
          spans[0].textContent = formatClock(shift.start);
          spans[1].textContent = formatClock(shift.end);
        }
      }
      if (calendarDay) {
        calendarDay.classList.add("work");
        calendarDay.style.setProperty(
          "--work-label",
          JSON.stringify(
            `work · ${formatClock(shift.start)}–${formatClock(shift.end)}`,
          ),
        );
      }
    });
  };
  function clearCloudWorkPlaceholders() {
    if (!currentUser?.cloud) return;
    $$(".week-grid .day.work", calendar).forEach((day) => {
      day.classList.remove("work");
      day.style.removeProperty("--work-label");
    });
    $$("#page-work .shift-week>div").forEach((slot) => {
      const day = $("b", slot)?.textContent || "";
      slot.classList.add("off");
      slot.innerHTML = `<b>${esc(day)}</b><small>Not set</small>`;
    });
  }
  // Do not paint prototype work hours during startup. The authenticated cloud
  // account supplies either its detected shifts or its saved schedule.
  const editSchedule = $$("#page-work button").find((b) =>
    b.textContent.includes("Edit schedule"),
  );
  if (editSchedule)
    editSchedule.onclick = () => {
      (prefs.workSchedule || []).forEach((shift, index) => {
        scheduleForm.elements[`start${index}`].value = shift.start;
        scheduleForm.elements[`end${index}`].value = shift.end;
      });
      scheduleEditor.classList.add("show");
    };
  // Work's two creation controls must create a work exception, not fall back
  // to the generic event editor inherited from the prototype shell.
  $$("#page-work .primary-action,#page-work .section-bar .ghost").forEach(
    (button) => {
      if (!/time off|add exception/i.test(button.textContent)) return;
      button.onclick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        api.openEditor("Work");
      };
    },
  );
  $(".schedule-close", scheduleEditor).onclick = () =>
    scheduleEditor.classList.remove("show");
  scheduleForm.onsubmit = (e) => {
    e.preventDefault();
    prefs.workSchedule = weekDays.map((day, index) => ({
      day,
      start: scheduleForm.elements[`start${index}`].value,
      end: scheduleForm.elements[`end${index}`].value,
    }));
    prefs.workScheduleSource = "manual";
    applyWorkSchedule(prefs.workSchedule);
    savePrefs();
    api.persist();
    scheduleEditor.classList.remove("show");
    flash("Work schedule saved across Calendar Guardian");
  };
})();
